// Get the modal
var curtain_modal = document.getElementById("curtain_configurator_modal");

// Get the button that opens the modal
var curtain_btn = document.getElementById("curtain_configurator_btn");

// Get the <span> element that closes the modal
var curtain_span = document.getElementById("curtain_configurator_close");


// When the user clicks the button, open the modal
curtain_btn.onclick = function () {
  curtain_modal.style.display = "block";
  $("body").css("overflow", "hidden");
};


// When the user clicks on <span> (x), close the modal
curtain_span.onclick = function () {
  curtain_modal.style.display = "none";
  $(".active-currency-wrp").show();
  $("body").css("overflow", "");
};


// When the user clicks anywhere outside of the modal, close it
/*
    window.onclick = function(event) {
      if (event.target == curtain_modal) {
        curtain_modal.style.display = "none";
      }
    }*/

$(".read-more-desc").click(function () {
  $(this).parents(".read-more-wrp").find(".step-detail").slideToggle();
  //$(".step-detail")
});

$(document).ready(function () {
  // $("#next-step-2").click(function () {
  //   var curtain_type_title = $(
  //     'input[name="properties[Curtain type]"]:checked'
  //   ).val();
  //   if (curtain_type_title == "Blinds") {
  //     $(".single-pair-wrp").hide();
  //     $(".header-wrp").hide();
  //     $(".style-wrp").hide();
  //   } else {
  //     $(".single-pair-wrp").show();
  //     $(".header-wrp").show();
  //     $(".style-wrp").show();
  //   }

  //   $(".step-1").hide();
  //   $(".step-2").show();

  //   // step price caculation
  //   var single_pair_price = $(
  //     'input[name="properties[Curtain type]"]:checked'
  //   ).val();

  //   if (single_pair_price == "Curtains") {
  //     var single_pair_price = $(
  //       'input[name="properties[Single / Pair]"]:checked'
  //     ).data("price-orignal");
  //     var single_heading = $('input[name="properties[Heading]"]:checked').data(
  //       "price-orignal"
  //     );
  //     var single_lining = $('input[name="properties[Lining]"]:checked').data(
  //       "price-orignal"
  //     );
  //     var totle_price_step_2 =
  //       single_pair_price + single_heading + single_lining;
  //   } else {
  //     var single_lining = $('input[name="properties[Lining]"]:checked').data(
  //       "price-orignal"
  //     );
  //     var totle_price_step_2 = single_lining;
  //   }

  //   $(".step-2 .right-header-wrp").attr("data-price", totle_price_step_2);
  //   $("#totel_price_step_2").val(totle_price_step_2);
  //   var totle_price_step_2 = theme.Currency.formatMoney(
  //     totle_price_step_2,
  //     theme.moneyFormat
  //   );

  //   $(".step-2 .right-header-wrp").html(totle_price_step_2);

  //   // Shopify.formatMoney(price,theme.moneyFormat)
  //   cunvertCurrency();
  // });
  // if the input with name properties[use-same-width] is clicked and true add the value 5 to the input with the id poles-width
  $('input[name="properties[use-same-width]"]').click(function () {
    if ($(this).is(":checked")) {
      var width_value = $('input[name="properties[Window width]').val();
      $("#poles-width").val(width_value);
      $("#rails-width").val(width_value);
      $('input[name="properties[use-same-width]"]').each(function () {
        $(this).prop("checked", true);
      });
    } else {
      $("#poles-width").val(0);
      $("#rails-width").val(0);
      $('input[name="properties[use-same-width]"]').each(function () {
        $(this).prop("checked", false);
      });
    }
  })

  var headingvelvet_product = $("#headingvelvet-product").val();
  if (headingvelvet_product == "true") {
    $(".heading-velvet-product").addClass("active");
    $(".heading-product").addClass("in-active");
    $(".heading-velvet-product:first input").trigger("click");
  } else {
    // $(".heading-product:first input").trigger("click");
  }
  productContentDetails();
  $(".step-1 input").click(function () {
    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    if (curtain_type_title == "Blinds") {
      var enable_third_step = $(".enable-third-step").val();
      if (enable_third_step == "true") {
        $(".second_step.preview-step").addClass("disactive");
        $(".second_step.preview-step").removeClass("active");
        $("#next-step-3").addClass("active");
        $("#next-step-3").removeClass("disactive");

        $(".preview-step-sec.back-step-2").addClass("disactive");
        $(".preview-step-sec.back-step-2").removeClass("active");
        $("#back-step-3").addClass("active");
        $("#back-step-3").removeClass("disactive");

        $(".next-step-3.breadcrumb_span").show();
        $(".next-step-3.breadcrumb_span").prev("svg").show();
      } else {
        $(".second_step.preview-step").removeClass("disactive");
        $(".second_step.preview-step").addClass("active");
        $("#next-step-3").removeClass("active");
        $("#next-step-3").addClass("disactive");

        $(".preview-step-sec.back-step-2").removeClass("disactive");
        $(".preview-step-sec.back-step-2").addClass("active");
        $("#back-step-3").removeClass("active");
        $("#back-step-3").addClass("disactive");

        $(".preview-list.finials-finish").hide();

        $(".next-step-3.breadcrumb_span").hide();
        $(".next-step-3.breadcrumb_span").prev("svg").hide();
      }

      $("#next-step-3").hide();
      $(".second_step.preview-step").show();
      $(".blind-product-wrp").hide();
    } else {
      //$('#next-step-3').show();
      $(".blind-product-wrp").hide();
      $(".second_step.preview-step").hide();

      $(".second_step.preview-step").addClass("disactive");
      $(".second_step.preview-step").removeClass("active");
      $("#next-step-3").addClass("active");
      $("#next-step-3").removeClass("disactive");

      $(".preview-step-sec.back-step-2").addClass("disactive");
      $(".preview-step-sec.back-step-2").removeClass("active");
      $("#back-step-3").addClass("active");
      $("#back-step-3").removeClass("disactive");

      $(".preview-list.finials-finish").show();

      $(".next-step-3.breadcrumb_span").show();
      $(".next-step-3.breadcrumb_span").prev("svg").show();
    }
  });

  window.showLiningReletedPro = function () {
    var lining_data_val = $('input[name="properties[Lining]"]:checked').data(
      "lining"
    );

    var breack_no_lining = "";
    $(".heading-options").each(function (index) {
      var heading_lining_data = $(this).data("lining");
      var heading_lining_data_arr = heading_lining_data.split(" ");
      $(heading_lining_data_arr).each(function () {
        if (this == lining_data_val) {
          breack_no_lining = true;
          return false;
        }
      });
    });

    if (breack_no_lining == true) {
      $(".heading-options").hide();
      $("." + lining_data_val).show();
      $(".no-lining-option").hide();
      var checkedIndex = parseInt($(".heading-options input[data-checked]").attr("data-checked"), 10) || 0;
      var newIndex = checkedIndex - 4;
      $("." + lining_data_val + " input").eq(newIndex).trigger("click");
    } else {
      $(".heading-options").hide();
      $(".no-lining-option").show();
      var checkedIndex = parseInt($(".heading-options input[data-checked]").attr("data-checked"), 10) || 0;
      var newIndex = checkedIndex - 4;
      $(".no-lining-option input").eq(newIndex).trigger("click");
    }
  };
  $(".lining-wrp input").click(function () {
    showLiningReletedPro();
  });

  $(".next-step-2").click(function () {
    $(".detail-wrp").animate({ scrollTop: 0 }, "300");

    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    if (curtain_type_title == "Blinds") {
      $(".single-pair-wrp").hide();
      $(".header-wrp").hide();
      $(".style-wrp").hide();
      $("input[value='No pole']").trigger("click");
      $('input[name="properties[pole width]"').val("");
      $('input[name="properties[rails-width]"').val("");
      $(".preview-list.finials-finish").hide();
      $(".preview-list.pole-style").hide();
      $(".preview-list.rails-width").hide();
      $(".preview-list.hanging-with").hide();

      var enable_third_step = $(".enable-third-step").val();

      if (enable_third_step == "false") {
        //alert();
        //$('.step-btn-2.next-step-3').hide();
        //$('.second_step.preview-step').show();
      } else {
        $(".poles-lbl").hide();
        $(".rails-lbl").hide();
      }

      var enable_third_step = $(".enable-third-step").val();
      if (enable_third_step == "true") {
        $(".second_step.preview-step").addClass("disactive");
        $(".second_step.preview-step").removeClass("active");
        $("#next-step-3").addClass("active");
        $("#next-step-3").removeClass("disactive");

        $(".preview-step-sec.back-step-2").addClass("disactive");
        $(".preview-step-sec.back-step-2").removeClass("active");
        $("#back-step-3").addClass("active");
        $("#back-step-3").removeClass("disactive");

        $(".next-step-3.breadcrumb_span").show();
        $(".next-step-3.breadcrumb_span").prev("svg").show();
      } else {
        $(".second_step.preview-step").removeClass("disactive");
        $(".second_step.preview-step").addClass("active");
        $("#next-step-3").removeClass("active");
        $("#next-step-3").addClass("disactive");

        $(".preview-step-sec.back-step-2").removeClass("disactive");
        $(".preview-step-sec.back-step-2").addClass("active");
        $("#back-step-3").removeClass("active");
        $("#back-step-3").addClass("disactive");

        $(".preview-list.finials-finish").hide();

        $(".next-step-3.breadcrumb_span").hide();
        $(".next-step-3.breadcrumb_span").prev("svg").hide();
      }

      $("#next-step-3").hide();
      //$('.step-2').removeClass('disable');
      $(".second_step.preview-step").show();
      $(".blind-product-wrp").hide();
    } else {
      $(".single-pair-wrp").show();
      $(".header-wrp").show();
      $(".style-wrp").show();

      $(".second_step.preview-step").removeClass("active");
      $("#next-step-3").addClass("active");
      $("#next-step-3").removeClass("disactive");

      $(".preview-step-sec.back-step-2").addClass("disactive");
      $(".preview-step-sec.back-step-2").removeClass("active");
      $("#back-step-3").addClass("active");
      $("#back-step-3").removeClass("disactive");

      $(".preview-list.finials-finish").show();

      $(".next-step-3.breadcrumb_span").show();
      $(".next-step-3.breadcrumb_span").prev("svg").show();
      $(".blind-product-wrp").hide();
    }

    $(".step-1").hide();
    $(".step-2").show();
    $(".step-2").removeClass("disable");

    // step price caculation
    var single_pair_price = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();

    if (single_pair_price == "Curtains") {
      var single_pair_price = $(
        'input[name="properties[Single / Pair]"]:checked'
      ).data("price-orignal");
      if (single_pair_price) {
        single_pair_price = single_pair_price;
      } else {
        single_pair_price = 0;
      }

      var single_heading = $('input[name="properties[Heading]"]:checked').data(
        "price-orignal"
      );
      if (single_heading) {
        single_heading = single_heading;
      } else {
        single_heading = 0;
      }
      var single_lining = $('input[name="properties[Lining]"]:checked').data(
        "price-orignal"
      );

      if (single_lining) {
        single_lining = single_lining;
      } else {
        single_lining = 0;
      }
      var totle_price_step_2 =
        single_pair_price + single_heading + single_lining;
    } else {
      var single_lining = $('input[name="properties[Lining]"]:checked').data(
        "price-orignal"
      );
      var blinds_product = $(
        'input[name="properties[Blinds Product]"]:checked'
      ).data("price-orignal");
      if (single_lining) {
        single_lining = single_lining;
      } else {
        single_lining = 0;
      }
      if (blinds_product) {
        blinds_product = blinds_product;
      } else {
        blinds_product = 0;
      }
      var totle_price_step_2 = blinds_product + single_lining;
    }
    var mainProductPrice = $(".main-product-price").attr("data-price");
    if (mainProductPrice && mainProductPrice != "NaN") {
      totle_price_step_2 = parseInt(mainProductPrice) + parseInt(totle_price_step_2);
    } else {
      mainProductPrice = $(".main-product-price").attr("data-main-price");
      if (mainProductPrice) {
        totle_price_step_2 = parseInt(mainProductPrice) + parseInt(totle_price_step_2);
      }
    }
    $(".step-2 .right-header-wrp").attr("data-price", totle_price_step_2);
    $("#totel_price_step_2").val(totle_price_step_2);
    var totle_price_step_2 = theme.Currency.formatMoney(
      totle_price_step_2,
      theme.moneyFormat
    );

    $(".step-2 .right-header-wrp").html(
      '<span class="fr from">Fr.</span> ' + totle_price_step_2
    );

    // Shopify.formatMoney(price,theme.moneyFormat)
    cunvertCurrency();

    $(".lining-options").each(function (index) {
      var lining_price_data = $(this).find("input").data("price-orignal");

      console.log("lining_price_data", lining_price_data);

      var lining_price = lining_price_data * 1;
      console.log("lining_price", lining_price);

      var lining_price_currency = theme.Currency.formatMoney(
        lining_price,
        theme.moneyFormat
      );

      console.log("lining_price_currency", lining_price_currency);

      $(this).find(".product-price").text(lining_price_currency);
    });

    // Show hading according to lining product
    showLiningReletedPro();
  });

  // get price on second step input click
  $(".step-2 input").click(function () {
    get_Amount_of_lenght();
    // price caculation
    var single_pair_price = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    var single_pair_selected = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).val();
    var window_width = $("#Window-width").val();
    var hight_width = $("#Height-drop").val();
    var final_fabric_meter = $("#final_fabric_meter").val();

    if (single_pair_price == "Curtains") {
      var single_pair_price = $(
        'input[name="properties[Single / Pair]"]:checked'
      ).data("price-orignal");
      if (single_pair_price) {
        single_pair_price = single_pair_price;
      } else {
        single_pair_price = 0;
      }

      var single_heading = $('input[name="properties[Heading]"]:checked').data(
        "price-orignal"
      );
      var count_of_lenght = $("#count-of-lenght").val();
      //alert(count_of_lenght);

      if (single_pair_selected == "Par") {
        if (single_heading) {
          single_heading = single_heading * count_of_lenght;
          single_heading = single_heading * 1;
        } else {
          single_heading = 0;
        }
      } else {
        if (single_heading) {
          single_heading = single_heading * count_of_lenght;
        } else {
          single_heading = 0;
        }
      }

      var single_lining = $('input[name="properties[Lining]"]:checked').data(
        "price-orignal"
      );
      if (single_lining) {
        single_lining = single_lining;
      } else {
        single_lining = 0;
      }

      if (window_width && hight_width) {
        single_lining = single_lining * final_fabric_meter;
      }

      var totle_price_step_2 =
        single_pair_price + single_heading + single_lining;
    } else {
      var single_lining = $('input[name="properties[Lining]"]:checked').data(
        "price-orignal"
      );
      var blinds_product = $(
        'input[name="properties[Blinds Product]"]:checked'
      ).data("price-orignal");
      if (single_lining) {
        single_lining = single_lining;
      } else {
        single_lining = 0;
      }
      if (blinds_product) {
        blinds_product = blinds_product;
      } else {
        blinds_product = 0;
      }
      if (window_width && hight_width) {
        single_lining = single_lining * final_fabric_meter;
      }
      var totle_price_step_2 = blinds_product + single_lining;
    }
    var mainProductPrice = $(".main-product-price").attr("data-price");
    if (mainProductPrice && mainProductPrice != "NaN") {
      totle_price_step_2 = parseInt(mainProductPrice) + parseInt(totle_price_step_2);
    } else {
      mainProductPrice = $(".main-product-price").attr("data-main-price");
      if (mainProductPrice) {
        if (single_pair_selected == "Par") {
          mainProductPrice = mainProductPrice * 1;
        }
        totle_price_step_2 = parseInt(mainProductPrice) + parseInt(totle_price_step_2);
      }
    }
    $(".step-2 .right-header-wrp").attr("data-price", totle_price_step_2);
    $("#totel_price_step_2").val(totle_price_step_2);
    var totle_price_step_2 = theme.Currency.formatMoney(
      totle_price_step_2,
      theme.moneyFormat
    );
    //$('.step-2 .right-header-wrp').html(totle_price_step_2);
    $(".step-2 .right-header-wrp").html(
      '<span class="fr from">Fr.</span> ' + totle_price_step_2
    );

    if (window_width) {
      setTimeout(function () {
        $(".right-header-wrp .fr").hide();
        $(".radio-btn-wrp .fr").hide();
      }, 200);
    }
  });

  $(".back-step-1").click(function () {
    $(".detail-wrp").animate({ scrollTop: 0 }, "300");
    $(".step-2").hide();
    $(".step-3").hide();
    $(".step-1").show();
    //$("#Window-width").val("");
    //$("#Height-drop").val("");
    $(".width-error-msg").text(" ");
    $(".height-error-msg").text(" ");
    $(".width-error-msg").text(" ");
    $(".height-width-error-msg").text(" ");
    $(".step-preview").addClass("disable");
  });
  $(".second_step.preview-step").click(function () {
    $(".custom_error_msg p").text(" ");
    var window_width = $("#Window-width").val();
    var window_height = $("#Height-drop").val();
    var window_height_error_msg = $("#window-height-error").val();
    var window_width_error_msg = $("#window-width-error").val();
    var window_width_height_error = $("#window-width-height-error").val();
    if (window_width && window_height) {
      $(".step-2").hide();
      $(".step-3").show();
      $(".height-error-msg").text(" ");
      $(".width-error-msg").text(" ");
      $(".height-width-error-msg").text(" ");
      $(".step-preview").removeClass("disable");
      $(".step-2").addClass("disable");
      $(".tab.step-preview").removeClass("disactive");
    } else {
      $(".tab.step-preview").addClass("disactive");
      var window_width = $("#Window-width").val();
      var window_height = $("#Height-drop").val();
      //alert('Height and width is required')
      var custom_error_msg = "";
      if (window_width == "" || window_height == "") {
        custom_error_msg = "Tomma fält";
      }
      $(".custom_error_msg p").text(custom_error_msg);
      if (window_height) {
        $(".height-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".height-error-msg").html(window_height_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }
      if (window_width) {
        $(".width-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".width-error-msg").text(window_width_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }
      if (window_width == "" && window_height == "") {
        $(".height-width-error-msg").html(window_width_height_error);
      } else if (window_width == "") {
        $(".height-width-error-msg").html(window_width_error_msg);
      } else if (window_height == "") {
        $(".height-width-error-msg").html(window_height_error_msg);
      }
    }
    $("#quantity").val(1);
  });

  $(".next-step-3").click(function () {
    var selected_pole_style = $(
      'input[name="properties[Pole style]"]:checked'
    ).val();
    if (selected_pole_style == "Poles") {
      $(".standard:first input").trigger("click");
    } else if (selected_pole_style == "exclusive") {
      $(".exclusive:first input").trigger("click");
    }
    $(".step-preview").hide();
    $(".detail-wrp").animate({ scrollTop: 0 }, "300");
    $(".custom_error_msg p").text(" ");
    var window_width = $("#Window-width").val();
    var window_height = $("#Height-drop").val();
    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    var window_height_error_msg = $("#window-height-error").val();
    var window_width_error_msg = $("#window-width-error").val();
    var window_width_height_error = $("#window-width-height-error").val();
    // showing error msg for height and width
    if (window_width && window_height) {
      $(".step-2").hide();
      $(".step-3").show();
      $(".height-error-msg").text(" ");
      $(".width-error-msg").text(" ");
      $(".height-width-error-msg").text(" ");
    } else {
      var window_width = $("#Window-width").val();
      var window_height = $("#Height-drop").val();
      //alert('Height and width is required')
      var custom_error_msg = "";
      if (window_width == "" || window_height == "") {
        custom_error_msg = "Tomma fält";
      }

      $(".custom_error_msg p").text(custom_error_msg);
      if (window_height) {
        $(".height-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".height-error-msg").html(window_height_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }
      if (window_width) {
        $(".width-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".width-error-msg").html(window_width_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }

      if (window_width == "" && window_height == "") {
        $(".height-width-error-msg").html(window_width_height_error);
      } else if (window_width == "") {
        $(".height-width-error-msg").html(window_width_error_msg);
      } else if (window_height == "") {
        $(".height-width-error-msg").html(window_height_error_msg);
      }
    }

    // showing selected option according curtain type
    if (curtain_type_title == "Blinds") {
      //$("input[value='Rails']").attr('checked', true);
      $("input[value='Rails']").trigger("click");

      $(".poles-lbl").hide();

      $(".no-pole-lbl label").text("No rails");
      $(".step-3 .left-header-wrp").text("3. Skena");
      $(".step-3 .step-pole-lbl").text("Rail style");
      $("input[value='No pole']").trigger("click");
    } else {
      $(".no-pole-lbl label").text("No poles");
      $(".step-3 .left-header-wrp").text("3. Upphängning");
      $(".step-3 .step-pole-lbl").text("Pole style");
      $(".poles-lbl").show();
      $("input[value='No pole']").attr("checked", true);
      $("input[value='No pole']").trigger("click");
    }

    // selected pole style
    var pole_style_val = $(".pole-style-wrp input:checked").val();

    if (pole_style_val == "Rails") {
      $(".finials-finish-rail-wrp").show();
      $(".finials-finish-wrp").hide();
    } else if (pole_style_val == "Poles" || pole_style_val == "exclusive") {
      $(".finials-finish-wrp").show();
      $(".finials-finish-rail-wrp").hide();

      if (pole_style_val == "Poles") {
        $(".standard").show();
        $(".exclusive").hide();
      } else {
        $(".standard").hide();
        $(".exclusive").show();
      }
    } else {
      $(".finials-finish-wrp").hide("slow");
      $(".finials-finish-rail-wrp").hide();
    }

    var pro_rails_val = $(".pro-rails-btn input:checked").val();
    if (pro_rails_val == "White Rail") {
      $(".white-rail-pro-wrp").show();
      $(".black-rail-pro-wrp").hide();
      $("#white-rails-1").prop("checked", true);
    } else {
      $(".white-rail-pro-wrp").hide();
      $(".black-rail-pro-wrp").show();
      $("#black-rails-1").prop("checked", true);
    }

    // step price caculation

    var step2_totel_price = parseInt($("#totel_price_step_2").val());

    //alert(step2_totel_price);

    if (pole_style_val == "Rails") {
      var rails_p_id_array = [];
      var rails_type = $(
        'input[name="properties[Finials & Finish Rails]"]:checked'
      ).val();

      if (rails_type == "White Rail") {
        $.each($("input[name='properties[White Rails]']:checked"), function () {
          var rails_p_id = parseInt($(this).data("price-orignal"));
          rails_p_id_array.push(rails_p_id);
        });

        if (rails_p_id_array[1]) {
          var totle_price_step_3 =
            step2_totel_price + rails_p_id_array[1] + rails_p_id_array[0];
        } else {
          var totle_price_step_3 = step2_totel_price + rails_p_id_array[0];
        }
      } else {
        $.each($("input[name='properties[Black Rails]']:checked"), function () {
          var rails_p_id = parseInt($(this).data("price-orignal"));
          rails_p_id_array.push(rails_p_id);
        });

        if (rails_p_id_array[1]) {
          var totle_price_step_3 =
            step2_totel_price + rails_p_id_array[1] + rails_p_id_array[0];
        } else {
          var totle_price_step_3 = step2_totel_price + rails_p_id_array[0];
        }
      }
    } else if (pole_style_val == "Poles" || pole_style_val == "exclusive") {
      var finials_finish_ori_price = $(
        'input[name="properties[Finials & Finish]"]:checked'
      ).data("price-orignal");
      if (finials_finish_ori_price) {
        finials_finish_ori_price = finials_finish_ori_price;
      } else {
        finials_finish_ori_price = 0;
      }

      var totle_price_step_3 = step2_totel_price + finials_finish_ori_price;
    } else {
      var totle_price_step_3 = step2_totel_price;
    }

    var totle_price_step_3 = theme.Currency.formatMoney(
      totle_price_step_3,
      theme.moneyFormat
    );

    $(".step-3 .right-header-wrp").html(totle_price_step_3);

    //document.getElementById("rails-width").value = "";
    //document.getElementById("poles-width").value = "";
    // call cunvertCurrency function
    cunvertCurrency();

    // Call function for hide poles and rails according to fabric style
    disalbePolesRails();

    if (curtain_type_title == "Blinds") {
      $("input[value='No pole']").trigger("click");
    }
  });

  // function for disable poles and rails for spacific fabric style
  function disalbePolesRails() {
    // Hide poles and rails using tags
    var heading_data_disable_poles = $(
      'input[name="properties[Heading]"]:checked'
    ).attr("data-disable-poles");
    var heading_data_disable_rails = $(
      'input[name="properties[Heading]"]:checked'
    ).attr("data-disable-rails");
    var lining_data_disable_poles = $(
      'input[name="properties[Lining]"]:checked'
    ).attr("data-disable-poles");
    var lining_data_disable_rails = $(
      'input[name="properties[Lining]"]:checked'
    ).attr("data-disable-rails");

    if (
      heading_data_disable_poles == "true" ||
      lining_data_disable_poles == "true"
    ) {
      var poles_disable_val = true;
    }

    if (
      heading_data_disable_rails == "true" ||
      lining_data_disable_rails == "true"
    ) {
      var rails_disable_val = true;
    }

    if (poles_disable_val == true && rails_disable_val == true) {
      $("input[value='No pole']").trigger("click");
      $(".pole-style-wrp .poles-lbl").hide();
      $(".pole-style-wrp .rails-lbl").hide();
    } else if (poles_disable_val == true) {
      $("input[value='No pole']").trigger("click");
      $(".pole-style-wrp .poles-lbl").hide();
      $(".pole-style-wrp .rails-lbl").show();
    } else if (rails_disable_val == true) {
      $("input[value='No pole']").trigger("click");
      $(".pole-style-wrp .rails-lbl").hide();
    } else {
      $(".pole-style-wrp .rails-lbl").show();
      $(".pole-style-wrp .poles-lbl").show();
      $("input[value='No pole']").trigger("click");
    }
  }

  // get price on second step input click
  // Click event for input for step 3.
  $(".step-3 input").click(function () {
    third_Stap_Cal();
  });

  window.third_Stap_Cal = function third_Stap_Cal() {
    var pole_style_val = $(".pole-style-wrp input:checked").val();

    var step2_totel_price = parseInt($("#totel_price_step_2").val());

    // step price caculation

    if (pole_style_val == "Rails") {
      var rails_width_val = $("#rails-width").val();
      if (rails_width_val < 100) {
        finials_finish_qty = 1;
        finials_finish_qty = finials_finish_qty;
      } else {
        rails_width_val = rails_width_val / 100;
        finials_finish_qty = Math.ceil(rails_width_val);
        finials_finish_qty = finials_finish_qty;
      }

      var finials_finish_ori_price = $(
        'input[name="properties[Finials & Finish Rails]"]:checked'
      ).data("price-orignal");
      finials_finish_ori_price = finials_finish_ori_price * finials_finish_qty;
      if (finials_finish_ori_price) {
        finials_finish_ori_price = finials_finish_ori_price;
      } else {
        finials_finish_ori_price = 0;
      }
      var totle_price_step_3 = step2_totel_price + finials_finish_ori_price;

      $(".rails-product").each(function (index) {
        var rails_price_data = $(this).find("input").data("price-orignal");
        var rails_price = rails_price_data * finials_finish_qty;
        var rails_price_currency = theme.Currency.formatMoney(
          rails_price,
          theme.moneyFormat
        );

        $(this).find(".product-price").text(rails_price_currency);
      });
    } else if (pole_style_val == "Poles" || pole_style_val == "exclusive") {
      var finials_finish_ori_price = $(
        'input[name="properties[Finials & Finish]"]:checked'
      ).data("price-orignal");
      if (finials_finish_ori_price) {
        finials_finish_ori_price = finials_finish_ori_price;
      } else {
        finials_finish_ori_price = 0;
      }

      var poles_width_val = parseInt($("#poles-width").val());
      if (!poles_width_val) {
        var poles_width_val = 0;
      }
      var finials_finish_qty = "";

      /* calculation for pole width qty */

      if (pole_style_val == "Poles") {
        if (poles_width_val < 250) {
          finials_finish_qty = 1;
        } else {
          poles_width_val = poles_width_val / 250;
          finials_finish_qty = Math.ceil(poles_width_val);
        }
        $(".standard").each(function (index) {
          var rails_price_data = $(this).find("input").data("price-orignal");
          var rails_price = rails_price_data * finials_finish_qty;
          var rails_price_currency = theme.Currency.formatMoney(
            rails_price,
            theme.moneyFormat
          );

          $(this).find(".product-price").text(rails_price_currency);
        });
      } else {
        if (poles_width_val < 100) {
          finials_finish_qty = 1;
        } else {
          poles_width_val = poles_width_val / 100;
          finials_finish_qty = Math.ceil(poles_width_val);
        }
        $(".exclusive").each(function (index) {
          var rails_price_data = $(this).find("input").data("price-orignal");
          var rails_price = rails_price_data * finials_finish_qty;
          var rails_price_currency = theme.Currency.formatMoney(
            rails_price,
            theme.moneyFormat
          );

          $(this).find(".product-price").text(rails_price_currency);
        });
      }
      finials_finish_ori_price = finials_finish_ori_price * finials_finish_qty;
      var totle_price_step_3 = step2_totel_price + finials_finish_ori_price;
    } else {
      var totle_price_step_3 = step2_totel_price;
    }

    var totle_price_step_3 = theme.Currency.formatMoney(
      totle_price_step_3,
      theme.moneyFormat
    );

    $(".step-3 .right-header-wrp").html(totle_price_step_3);
  };

  $(".back-step-2").click(function () {
    $(".detail-wrp").animate({ scrollTop: 0 }, "300");
    $(".step-3").hide();
    $(".step-2").show();
    $(".step-2").removeClass("disable");
    var window_width = $("#Window-width").val();
    var window_height = $("#Height-drop").val();

    if (window_width != "") {
      $(".width-error-msg").text(" ");
    }

    if (window_height != "") {
      $(".height-error-msg").text(" ");
    }
    $(".step-preview").addClass("disable");
  });

  $(".preview-step-sec.back-step-2").click(function () {
    $(".step-preview").hide();
    $(".step-2").show();
    $(".step-2").removeClass("disable");
  });

  // Back button click even for step 3
  $("#back-step-3").click(function () {
    $(".detail-wrp").animate({ scrollTop: 0 }, "300");
    $(".step-preview").hide();
    $(".step-3").show();
    //document.getElementById("rails-width").value = "";
    //document.getElementById("poles-width").value = "";
    $(".height-error-msg").text(" ");
    $(".width-error-msg").text(" ");
  });

  // Preview step event for perview all selected option for finel step
  $(".preview-step").click(function () {
    $(".finials-finish").removeClass("disable");

    $(".detail-wrp").animate({ scrollTop: 0 }, "300");

    $(".custom_error_msg p").text(" ");
    var window_width = $("#Window-width").val();
    var window_height = $("#Height-drop").val();
    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    var window_height_error_msg = $("#window-height-error").val();
    var window_width_error_msg = $("#window-width-error").val();
    var window_width_height_error = $("#window-width-height-error").val();
    // showing error msg for height and width
    //if(curtain_type_title == 'Curtains'){
    $(".step-preview").removeClass("disable");
    //}
    if (window_width && window_height) {
      $(".step-2").hide();
      $(".step-3").show();
      $(".height-error-msg").text(" ");
      $(".width-error-msg").text(" ");
      $(".height-width-error-msg").text(" ");
    } else {
      var window_width = $("#Window-width").val();
      var window_height = $("#Height-drop").val();
      //alert('Height and width is required')
      var custom_error_msg = "";
      if (window_width == "" || window_height == "") {
        custom_error_msg = "Tomma fält";
      }

      $(".custom_error_msg p").text(custom_error_msg);
      if (window_height) {
        $(".height-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".height-error-msg").html(window_height_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }
      if (window_width) {
        $(".width-error-msg").text(" ");
        $(".height-width-error-msg").text(" ");
      } else {
        $(".width-error-msg").html(window_width_error_msg);
        $(".height-width-error-msg").html(window_width_error_msg);
      }

      if (window_width == "" && window_height == "") {
        $(".height-width-error-msg").html(window_width_height_error);
      } else if (window_width == "") {
        $(".height-width-error-msg").html(window_width_error_msg);
      } else if (window_height == "") {
        $(".height-width-error-msg").html(window_height_error_msg);
      }
    }

    // var main_pro_v_id = $("select[data-variant-input]").val();
    var main_select = $("select[data-variant-input]");
    var selectedOption = main_select.find("option:selected");
    var main_pro_v_id = selectedOption.attr("data-variant-id");

    var cc_vartical_pattern_repeat = $(
      ".cc_vid_" + main_pro_v_id + " .vartical_pattern_repeat"
    ).val();
    console.log("cc_vartical_pattern_repeat", cc_vartical_pattern_repeat);
    var cc_needed_fabric_ratio = $(
      ".cc_vid_" + main_pro_v_id + " .needed_fabric_ratio"
    ).val();
    var cc_width = $(".cc_vid_" + main_pro_v_id + " .width").val();

    // windowwidth
    var Window_width = $('input[name="properties[Window width]"]').val();
    // Height drop
    var Height_drop = $('input[name="properties[Height drop]"]').val();

    if (curtain_type_title == "Curtains") {
      // Call CcCalculatur function
      CcCalculatur(
        Height_drop,
        Window_width,
        cc_width,
        cc_needed_fabric_ratio,
        cc_vartical_pattern_repeat
      );
    } else {
      // Call CcCalculatur function
      BliendCcCalculatur(
        Height_drop,
        Window_width,
        cc_width,
        cc_needed_fabric_ratio,
        cc_vartical_pattern_repeat
      );
    }
    // main product
    var main_product_img = $(".pwzrswiper-slide-active img").attr("src");

    var main_product_title = $(".product-single__title").text();
    // var main_product_price = $('.product-title-main-price').text();
    var main_product_variant = $(".swatch .header").html();

    // curtain type
    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    var curtain_type_price = $(
      'input[name="properties[Curtain type]"]:checked'
    ).data("price-orignal");
    var curtain_type_price = theme.Currency.formatMoney(
      curtain_type_price,
      theme.moneyFormat
    );
    var curtain_type_src = $(
      'input[name="properties[Curtain type]"]:checked'
    ).data("src");

    var curtain_type_price_orignal = $(
      'input[name="properties[Curtain type]"]:checked'
    ).data("price-orignal");

    // Quantity
    var quantity_title = $('input[name="properties[quantity]"]').val();

    // single pair
    var single_pair_type_title = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).val();
    var single_pair_type_price = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).data("price-orignal");
    if (single_pair_type_price == 0) {
      $(".preview-list.single-Pair").addClass("disable");
    }
    var single_pair_type_price = theme.Currency.formatMoney(
      single_pair_type_price,
      theme.moneyFormat
    );

    var single_pair_type_src = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).data("src");

    if (single_pair_type_src == undefined) {
      $(".step-preview .single-Pair").addClass("dis-active");
    }
    var single_pair_price_orignal = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).data("price-orignal");

    // bliend product
    var bliend_product_title = $(
      'input[name="properties[Blinds Product]"]:checked'
    ).val();
    var bliend_product_price = $(
      'input[name="properties[Blinds Product]"]:checked'
    ).data("price-orignal");
    if (bliend_product_price == 0) {
      $(".preview-list.blind-pro-type").addClass("disable");
    }
    var bliend_product_price = theme.Currency.formatMoney(
      bliend_product_price,
      theme.moneyFormat
    );

    var bliend_product_src = $(
      'input[name="properties[Blinds Product]"]:checked'
    ).data("src");

    if (bliend_product_src == undefined) {
      $(".step-preview .blind-pro-type").addClass("dis-active");
    }
    var bliend_product_orignal = $(
      'input[name="properties[Blinds Product]"]:checked'
    ).data("price-orignal");

    // style
    var style_title = $('input[name="properties[style]"]:checked').val();
    var style_src = $('input[name="properties[style]"]:checked').data("src");

    // heading type
    var heading_type_title = $(
      'input[name="properties[Heading]"]:checked'
    ).val();
    //var single_pair_selected = $('input[name="properties[Single / Pair]"]:checked').val();
    var heading_type_price = $(
      'input[name="properties[Heading]"]:checked'
    ).data("price-orignal");
    var count_of_lenght = $("#count-of-lenght").val();

    if (heading_type_price == 0) {
      $(".preview-list.heading").addClass("disable");
    } else {
      if (single_pair_type_title == "Par") {
        heading_type_price = heading_type_price * count_of_lenght;

        heading_type_price = heading_type_price * 1;
      } else {
        heading_type_price = heading_type_price * count_of_lenght;
      }
    }


    $(".heading-price").attr("data-price", heading_type_price);
    var heading_type_price = theme.Currency.formatMoney(
      heading_type_price,
      theme.moneyFormat
    );
    var heading_type_src = $('input[name="properties[Heading]"]:checked').data(
      "src"
    );
    var heading_price_orignal = $(
      'input[name="properties[Heading]"]:checked'
    ).data("price-orignal");
    heading_price_orignal = heading_price_orignal * count_of_lenght;
    var count_of_lenght = $("#count-of-lenght").val();
    if (single_pair_type_title == "Par") {
      single_pair_type_title = "Antal: 2 (1 pair)";
      heading_price_orignal = heading_price_orignal * 1;
    } else {
      single_pair_type_title = "Antal: 1 (1 single)";
      heading_price_orignal = heading_price_orignal;
    }

    if (heading_type_src == undefined) {
      $(".step-preview .heading").addClass("dis-active");
    }

    // lining type
    var lining_type_title = $('input[name="properties[Lining]"]:checked').val();
    var lining_type_price = $('input[name="properties[Lining]"]:checked').data(
      "price-orignal"
    );

    if (lining_type_price == 0) {
      $(".preview-list.lining").addClass("disable");
    }

    var final_fabric_meter = parseInt($("#final_fabric_meter").val());
    var lining_type_price = lining_type_price * final_fabric_meter;

    $(".lining-price").attr("data-price", lining_type_price);
    var lining_type_price = theme.Currency.formatMoney(
      lining_type_price,
      theme.moneyFormat
    );
    var lining_type_src = $('input[name="properties[Lining]"]:checked').data(
      "src"
    );
    var lining_price_orignal = $(
      'input[name="properties[Lining]"]:checked'
    ).data("price-orignal");

    if (lining_type_src == undefined) {
      $(".step-preview .lining").addClass("dis-active");
    }

    // pole style
    var pole_style_type_title = $(
      'input[name="properties[Pole style]"]:checked'
    ).val();

    var pole_style_type_price = $(
      'input[name="properties[Pole style]"]:checked'
    ).data("price-orignal");
    if (pole_style_type_price == 0) {
      $(".preview-list.pole-style").addClass("disable");
      $(".preview-list.pole-style").addClass("finials-finish");
    }
    var pole_style_type_price = theme.Currency.formatMoney(
      pole_style_type_price,
      theme.moneyFormat
    );
    var pole_style_type_src = $(
      'input[name="properties[Pole style]"]:checked'
    ).data("src");
    var pole_style_price_orignal = $(
      'input[name="properties[Pole style]"]:checked'
    ).data("price-orignal");

    // finials finish type
    var finials_finish_type_title = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).val();
    var finials_finish_style_type_price = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).data("price-orignal");

    var finials_finish_pro_type = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).data("producttype");
    var poles_width_val = parseInt($("#poles-width").val());
    var rails_width_val = parseInt($("#rails-width").val());
    var finials_finish_qty = "";

    /* calculation for pole width qty */

    if (finials_finish_pro_type == "standard") {
      if (poles_width_val < 250) {
        finials_finish_qty = 1;
      } else {
        poles_width_val = poles_width_val / 250;
        finials_finish_qty = Math.ceil(poles_width_val);
      }
    } else if (finials_finish_pro_type == "exclusive") {
      if (poles_width_val < 100) {
        finials_finish_qty = 1;
      } else {
        poles_width_val = poles_width_val / 100;
        finials_finish_qty = Math.ceil(poles_width_val);
      }
    } else {
      if (rails_width_val < 100) {
        finials_finish_qty = 1;
      } else {
        rails_width_val = rails_width_val / 100;
        finials_finish_qty = Math.ceil(rails_width_val);
      }
    }

    var finials_finish_style_type_price =
      finials_finish_style_type_price * finials_finish_qty;

    var finials_finish_style_type_price = theme.Currency.formatMoney(
      finials_finish_style_type_price,
      theme.moneyFormat
    );
    var finials_finish_style_type_src = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).data("src");
    var finials_finish_style_price_orignal = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).data("price-orignal");
    if (
      finials_finish_style_price_orignal == 0 &&
      (pole_style_type_title == "Poles" || pole_style_type_title == "exclusive")
    ) {
      $(".preview-list.finials-finish").addClass("disable");
      $(".preview-list.finials-finish").show();
    }
    if (finials_finish_style_type_src == undefined) {
      $(".step-preview .finials-finish").addClass("dis-active");
    }

    var finials_finish_rails_style_type_src = $(
      'input[name="properties[Finials & Finish Rails]"]:checked'
    ).data("src");
    var finials_finish_rails_style_price_orignal = $(
      'input[name="properties[Finials & Finish Rails]"]:checked'
    ).data("price-orignal");
    if (
      finials_finish_rails_style_price_orignal == 0 &&
      pole_style_type_title == "Rails"
    ) {
      $(".preview-list.finials-finish").addClass("disable");
      $(".preview-list.finials-finish").show();
    }
    if (finials_finish_rails_style_type_src == undefined) {
      $(".step-preview .finials-finish").addClass("dis-active");
    }

    if (
      pole_style_type_title == "Poles" ||
      pole_style_type_title == "exclusive"
    ) {
      finials_finish_style_price_orignal = finials_finish_style_price_orignal;
    } else if (pole_style_type_title == "Rails") {
      finials_finish_style_price_orignal =
        finials_finish_rails_style_price_orignal;
    } else {
      finials_finish_style_price_orignal = 0;
    }

    // finials finish rail type
    var finials_finish_type_rails_title = $(
      'input[name="properties[Finials & Finish Rails]"]:checked'
    ).val();

    var rails_heading_option = $("#rails-heading-option").val();
    var totle_fabric_meter = $(".totle-fabric-meter").val();

    var finials_finish_pro_type = $(
      'input[name="properties[Finials & Finish]"]:checked'
    ).data("producttype");
    var poles_width_val = parseInt($("#poles-width").val());
    var rails_width_val = parseInt($("#rails-width").val());

    var finials_finish_qty = "";

    /* calculation for pole width qty */
    if (pole_style_type_title == "Poles") {
      if (poles_width_val < 250) {
        finials_finish_qty = 1;
      } else {
        poles_width_val = poles_width_val / 250;
        finials_finish_qty = Math.ceil(poles_width_val);
      }
      //finials_finish_style_price_orignal = finials_finish_style_price_orignal * finials_finish_qty;
    } else if (pole_style_type_title == "exclusive") {
      if (poles_width_val < 100) {
        finials_finish_qty = 1;
      } else {
        poles_width_val = poles_width_val / 100;
        finials_finish_qty = Math.ceil(poles_width_val);
      }
      //finials_finish_style_price_orignal = finials_finish_style_price_orignal * finials_finish_qty;
    } else {
      if (rails_width_val < 100) {
        finials_finish_qty = 1;
      } else {
        rails_width_val = rails_width_val / 100;
        finials_finish_qty = Math.ceil(rails_width_val);
      }
    }

    finials_finish_style_price_orignal =
      finials_finish_style_price_orignal * finials_finish_qty;


    // finials finish rails type
    var finials_finish_rails_type_title = $(
      'input[name="properties[Finials & Finish Rails]"]:checked'
    ).val();
    var finials_finish_rails_style_type_price = $(
      'input[name="properties[Finials & Finish Rails]"]:checked'
    ).data("price-orignal");
    finials_finish_rails_style_type_price =
      finials_finish_rails_style_type_price * finials_finish_qty;

    var finials_finish_rails_style_type_price = theme.Currency.formatMoney(
      finials_finish_rails_style_type_price,
      theme.moneyFormat
    );


    $(".preview-price.finials-finish-price").attr(
      "data-price",
      finials_finish_style_price_orignal
    );

    // total orignal price

    /*
      alert("curtain_type_price_orignal +"+curtain_type_price_orignal);
      alert("single_pair_price_orignal +"+single_pair_price_orignal);
      alert("heading_price_orignal +"+heading_price_orignal);
      alert("lining_price_orignal +"+lining_price_orignal);
      alert("finials_finish_style_price_orignal +"+finials_finish_style_price_orignal);
            */
    //var main_product_price = $('.main-product-price').val();

    var main_product_price = $(".price-item--regular .money").attr(
      "doubly-currency-sek"
    );
    totle_fabric_meter = parseInt(totle_fabric_meter);
    var style_value = $('input[name="properties[style]"]:checked').val();
    if (style_value == "Dekorativ gardin") {
      var one_third_fabric_needed_per_curtain_m = totle_fabric_meter / 3;
      var fabric_needed_per_curtain_cm = totle_fabric_meter - one_third_fabric_needed_per_curtain_m;
      totle_fabric_meter = Math.ceil(fabric_needed_per_curtain_cm);
    }
    

    lining_price_orignal = totle_fabric_meter * lining_price_orignal;

    console.log("lining_price_orignal", lining_price_orignal);
    var enable_third_step = $(".enable-third-step").val();

    var blinds_product = $(
      'input[name="properties[Blinds Product]"]:checked'
    ).data("price-orignal");
    if (blinds_product) {
      blinds_product = blinds_product;
    } else {
      blinds_product = 0;
    }
    if (enable_third_step == "true" && curtain_type_title == "Blinds") {
      var total_orignal_price =
        (curtain_type_price_orignal || 0) +
        (single_pair_price_orignal || 0) +
        (lining_price_orignal || 0) +
        (finials_finish_style_price_orignal || 0) +
        (blinds_product || 0);
    } else if (enable_third_step == "false" && curtain_type_title == "Blinds") {
      var total_orignal_price =
        (curtain_type_price_orignal || 0) +
        (single_pair_price_orignal || 0) +
        (lining_price_orignal || 0) +
        (blinds_product || 0);
    } else {
      if (pole_style_type_title == "No pole") {
        var total_orignal_price =
          curtain_type_price_orignal +
          single_pair_price_orignal +
          heading_price_orignal +
          lining_price_orignal;
      } else {
        var total_orignal_price =
          curtain_type_price_orignal +
          single_pair_price_orignal +
          heading_price_orignal +
          lining_price_orignal +
          finials_finish_style_price_orignal;
      }
    }
    /*
            alert("orignal price"+curtain_type_price_orignal);
            alert("single_pair_price_orignal price"+single_pair_price_orignal);
            alert("heading_price_orignal price"+heading_price_orignal);
          alert("lining_price_orignal price"+lining_price_orignal);
           alert("finials_finish_style_price_orignal price"+finials_finish_style_price_orignal);*/

    main_product_price = parseFloat(main_product_price);
    total_orignal_price = parseFloat(total_orignal_price);

    var regular_main_price = $(
      ".orignal-price-wrp .price-item--regular-wrp"
    ).data("price");

    //main_product_price = totle_fabric_meter * main_product_price;
    regular_main_price = totle_fabric_meter * regular_main_price;
    //total_orignal_price = total_orignal_price + main_product_price;
    total_orignal_price = total_orignal_price + regular_main_price;
    $(".totle-orignal-price").attr("data-price", total_orignal_price);
    var total_orignal_price = theme.Currency.formatMoney(
      total_orignal_price,
      theme.moneyFormat
    );

    //alert(finials_finish_style_price_orignal);
    $(".main-product-img").attr("src", main_product_img);
    $(".main-product-title").text(main_product_title);
    //$('.main-product-price').text(main_product_price);
    //$('.main-product-variant').html(main_product_variant);

    $(".curtain-type-img").attr("src", curtain_type_src);

    $(".curtain-type-title").text(curtain_type_title);
    $(".curtain-type-price").html(curtain_type_price);

    $(".qantity-title").text(quantity_title);

    if (curtain_type_title == "Blinds") {
      $(".single-Pair").hide();
    } else {
      $(".single-Pair").show();
      $(".single-Pair-img").attr("src", single_pair_type_src);
      $(".single-Pair-title").html(single_pair_type_title);
      $(".single-Pair-price").html(single_pair_type_price);
    }

    if (curtain_type_title == "Blinds") {
      $(".blind-pro-type").show();
      $(".blind-pro-img").attr("src", bliend_product_src);
      $(".blind-pro-title").html(bliend_product_title);
      $(".blind-pro-price").html(bliend_product_price);
      $(".preview-list.style").hide();
    } else {
      $(".preview-list.style").show();
      $(".style-img").attr("src", style_src);
      $(".style-title").html(style_title);
    }

    $(".window-width-title").text(Window_width);
    $(".height-drop-title").text(Height_drop);

    if (curtain_type_title == "Blinds") {
      $(".preview-list.heading").hide();
    } else {
      $(".preview-list.heading").show();
      $(".heading-img").attr("src", heading_type_src);
      $(".heading-title").text(heading_type_title);
      $(".heading-price").html(heading_type_price);
    }

    $(".lining-img").attr("src", lining_type_src);
    if (lining_type_title == "No lining") {
      lining_type_title = "Ingen Foder";
    }
    $(".lining-title").text(lining_type_title);
    $(".lining-price").html(lining_type_price);

    if (curtain_type_title == "Blinds") {
      $(".preview-list.pole-style").hide();
    } else {
      $(".preview-list.pole-style").show();
      $(".pole-style-img").attr("src", pole_style_type_src);
      if (pole_style_type_title == "Poles") {
        pole_style_type_title = "Stänger";
      }
      if (pole_style_type_title == "Rails") {
        pole_style_type_title = "skena";
      }
      $(".pole-style-title").text(pole_style_type_title);
      $(".pole-style-price").html(pole_style_type_price);
    }

    var pole_style_val = $(".pole-style-wrp input:checked").val();
    if (pole_style_val == "Rails") {
      $(".finials-finish-img").attr("src", finials_finish_rails_style_type_src);
      $(".finials-finish-title").html(finials_finish_rails_type_title);
      $(".finials-finish-price").html(finials_finish_rails_style_type_price);
      $(".hanging-with-title").text(rails_heading_option);
      $(".preview-list.hanging-with").show();

      $('input[name="properties[pole width]"]').val("");
      var rails_width = parseInt(
        $('input[name="properties[rails width]"]').val()
      );

      if (rails_width) {
        $(".rails-width-title").text(rails_width);
        $(".finials-finish-width-wrp").text(" ");
        $(".preview-list.rails-width").show();
      } else {
        $(".preview-list.rails-width").hide();
      }
      $(".preview-list.pole-width").hide();
      $(".preview-list.rails-width").show();
      $(".preview-list.finials-finish").show();
      //$('.finials-finish').hide();
    } else if (pole_style_val == "Poles" || pole_style_val == "exclusive") {
      $(".finials-finish-img").attr("src", finials_finish_style_type_src);
      $(".finials-finish-title").html(finials_finish_type_title);
      $(".finials-finish-price").html(finials_finish_style_type_price);
      $(".preview-list.hanging-with").hide();
      $('input[name="properties[rails width]"]').val("");
      var pole_width = parseInt(
        $('input[name="properties[pole width]"]').val()
      );
      var f_finish_pole_width = $(
        'input[name="properties[Finials & Finish]"]:checked'
      ).attr("data-add-pole-margin");
      if (f_finish_pole_width == "true") {
        var pole_width = pole_width + 5;
      } else {
        var pole_width = pole_width;
      }
      if (pole_width) {
        if (f_finish_pole_width == "true") {
          $(".pole-width-title").text(pole_width - 5);
        } else {
          $(".pole-width-title").text(pole_width);
        }

        if (pole_width) {
          $(".finials-finish-width-wrp").text(
            "Totalt stångbredd: " + pole_width
          );
        }
        $(".preview-list.pole-width").show();
      } else {
        $(".preview-list.pole-width").hide();
        $(".finials-finish-width-wrp").text(" ");
      }
      $(".preview-list.rails-width").hide();
      $(".preview-list.pole-width").show();
      $(".preview-list.finials-finish").show();
    } else {
      $(".preview-list.finials-finish").hide();
      $(".preview-list.hanging-with").hide();
      $(".preview-list.rails-width").hide();
      $(".preview-list.pole-width").hide();
    }

    $(".totle-orignal-price").html(total_orignal_price);

    if (curtain_type_title == "Curtains") {
      if (
        pole_style_type_title == "Stänger" ||
        pole_style_type_title == "exclusive"
      ) {
        var pole_width_val = $('input[name="properties[pole width]"]').val();
        var pole_width_val = $.trim(pole_width_val);
        if (pole_width_val) {
          $(".step-3").hide();
          $(".step-preview").show();
          $(".pole-width-error-msg").text(" ");
          $(".bottom-footer-wrp .pole-width-error-msg").text(" ");
        } else {
          $(".pole-width-error-msg").text("Stångbredd krävs");
          $(".bottom-footer-wrp .pole-width-error-msg").text(
            "Stångbredd krävs"
          );
        }
      } else if (pole_style_type_title == "skena") {
        var rails_width_val = $('input[name="properties[rails width]"]').val();
        var rails_width_val = $.trim(rails_width_val);
        if (rails_width_val) {
          $(".step-3").hide();
          $(".step-preview").show();
          $(".pole-width-error-msg").text(" ");
          $(".bottom-footer-wrp .pole-width-error-msg").text(" ");
        } else {
          $(".rails-width-error-msg").text("Skenans bredd krävs");
          $(".bottom-footer-wrp .pole-width-error-msg").text(
            "Skenans bredd krävs"
          );
        }
      } else {
        $(".step-3").hide();
        $(".step-preview").show();
        $(".pole-width-error-msg").text(" ");
        $(".bottom-footer-wrp .pole-width-error-msg").text(" ");
        $(".rails-width-error-msg").text(" ");
      }
      $(".blind-pro-type").hide();
    } else {
      $(".preview-list.pole-width").hide();
      $(".step-3").hide();
      $(".step-preview").show();
    }

    cunvertCurrency();
    $("#quantity").val(1);
  });

  // get selected id for variant

  $("#last-step-add-to-cart").click(function () {
    $(".pageloader").show();
    var main_select = $("select[data-variant-input]");
    var selectedOption = main_select.find("option:selected");
    var main_pro_id = parseInt(selectedOption.attr("data-variant-id"), 10);
    // var main_pro_id = $("#ProductSelect-product-template").val();
    var final_fabric_meter = parseInt($("#final_fabric_meter").val());

    //var quantity = $('input[name="properties[quantity]"]').val();
    var quantity = 1;
    var curtain_type_val = $('input[name="properties[Curtain type]"]').val();
    var style_type_val = $('input[name="properties[style]"]').val();
    var pole_type_val = $(".pole-style-wrp input:checked").val();
    if (pole_type_val == "Poles" || pole_type_val == "exclusive") {
      pole_type_val = "stång";
    } else if (pole_type_val == "Rails") {
      pole_type_val = "Skena";
    } else {
      pole_type_val = "Ingen upphängning";
    }

    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    //var pro_qty = $('.quantity-wrp #quantity').val();
    var pro_qty = 1;
    var final_fabric_meter = parseInt($("#final_fabric_meter").val());
    var final_fabric_meter = final_fabric_meter;
    //var rails_width_value = parseInt($('input[name="properties[rails width]"]').val());

    // showing in backedn
    var single_pair_type_title = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).val();
    if (single_pair_type_title == "Par") {
      antal_val = "2 (1 Par)"; //'Amount: 2 (1 pair)'
    } else {
      antal_val = "1 (1 Singel)"; //'Amount: 1 (1 single)'
    }

    var style_title = $('input[name="properties[style]"]:checked').val();
    var heading_title = $('input[name="properties[Heading]"]:checked').val();
    var lining_title = $('input[name="properties[Lining]"]:checked').val();
    if (lining_title == "No lining") {
      lining_title = "Ingen Foder";
    }
    // windowwidth
    var Window_width = $('input[name="properties[Window width]"]').val();
    // Height drop
    var Height_drop = $('input[name="properties[Height drop]"]').val();

    var curtain_type_title = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();
    var pole_style_type_title = $(
      'input[name="properties[Pole style]"]:checked'
    ).val();
    var pole_width = $('input[name="properties[pole width]"').val();
    var rails_width = $('input[name="properties[rails width]"').val();
    if (pole_width) {
      var poles_rails_width = pole_width;
    } else {
      var poles_rails_width = rails_width;
    }
    var main_product_price = $(".main-product-price").html();
    var totle_orignal_price = $(".totle-orignal-price").html();

    var heading_pro_qty = parseInt($("#count-of-lenght").val(), 10);
    var heading_price = $('input[name="properties[Heading]"]:checked').data(
      "price-orignal"
    );
    var antal_vader = heading_price * heading_pro_qty;
    if (single_pair_type_title == "Par") {
      var antal_vader = antal_vader * 1;
    } else {
      var antal_vader = antal_vader;
    }
    if (single_pair_type_title == "Par") {
      var heading_pro_qty = heading_pro_qty * 1;
    } else {
      var heading_pro_qty = heading_pro_qty;
    }

    //var main_product_price = $('.main-product-price').data('price');
    var antal_vader = theme.Currency.formatMoney(
      antal_vader,
      theme.moneyFormat
    );

    var totle_orignal_price = $(".totle-orignal-price").data("price");
    var totle_orignal_price = theme.Currency.formatMoney(
      totle_orignal_price,
      theme.moneyFormat
    );

    var model_price = $(".step-2 .right-header-wrp").html();

    if (curtain_type_title == "Blinds") {
      /*@@@ replace the title*/
      curtain_type_title = "Hissgardiner";
      /*End*/
      var single_pair_pro_id = parseInt(
        $('input[name="properties[Single / Pair]"]:checked').attr("product-id")
      );
      //var single_pair_pro_id =  parseInt('41282593915058');
      var heading_pro_id = parseInt(
        $('input[name="properties[Heading]"]:checked').attr("product-id")
      );
      var lining_pair_pro_id = parseInt(
        $('input[name="properties[Lining]"]:checked').attr("product-id")
      );
      var blinds_pro_id = parseInt(
        $('input[name="properties[Blinds Product]"]:checked').attr("product-id")
      );

      var pole_style_pro_id = $(
        'input[name="properties[Pole style]"]:checked'
      ).val();
      var linign_value = $('input[name="properties[Lining]"]:checked').val();

      var rails_width_value = parseInt(
        $('input[name="properties[rails width]"]').val()
      );
      if (rails_width_value) {
        rails_width_value = rails_width_value;
      } else {
        rails_width_value = 0;
      }

      var blinds_pro_array = {
        quantity: pro_qty,
        id: blinds_pro_id,
        properties: {
          child: new Date().getTime(),
        },
      };

      if (pole_style_pro_id == "Poles" || pole_style_pro_id == "exclusive") {
        var finials_finish_pro_id = parseInt(
          $('input[name="properties[Finials & Finish]"]:checked').attr(
            "product-id"
          )
        );
        if (linign_value == "No lining") {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                parent: new Date().getTime(),
              },
            },
          ];
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        } else {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                parent: new Date().getTime(),
              },
            },
            {
              quantity: final_fabric_meter,
              id: lining_pair_pro_id,
              properties: {
                child: new Date().getTime(),
              },
            },
          ];
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        }
      } else if (pole_style_pro_id == "Rails") {
        var finials_finish_pro_id = parseInt(
          $('input[name="properties[Finials & Finish Rails]"]:checked').attr(
            "product-id"
          )
        );
        var finials_finish_pro_array = {
          quantity: pro_qty,
          id: finials_finish_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };
        var lining_pair_pro_array = {
          quantity: final_fabric_meter,
          id: lining_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };

        var hanging_with = $("#rails-heading-option").val();
        if (linign_value == "No lining") {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Rails width: ": rails_width_value + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                "Umgås med: ": hanging_with,
                parent: new Date().getTime(),
              },
            },
          ];
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        } else {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Rails width: ": rails_width_value + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                "Umgås med: ": hanging_with,
                parent: new Date().getTime(),
              },
            },
          ];
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        }
      } else {
        var lining_pair_pro_array = {
          quantity: final_fabric_meter,
          id: lining_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };

        if (linign_value == "No lining") {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                parent: new Date().getTime(),
              },
            },
          ];
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        } else {
          /* check krna he */
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Fallhöjd: ": Height_drop + " Cm",
                "Underprodukt kvantitet: ": quantity,
                "Gardintyp: ": curtain_type_title,
                "Stiltyp: ": style_type_val,
                "Typ av stolpe: ": pole_type_val,
                parent: new Date().getTime(),
              },
            },
          ];
          if (lining_pair_pro_id) {
            data.push(lining_pair_pro_array);
          }
          if (blinds_pro_id) {
            data.push(blinds_pro_array);
          }
        }
      }
    } else {
      /*@@@ replace the title*/
      curtain_type_title = "Gardinlängder";
      /*End*/
      var single_pair_pro_id = parseInt(
        $('input[name="properties[Single / Pair]"]:checked').attr("product-id")
      );
      //var single_pair_pro_id =  parseInt('41282593915058');
      var heading_pro_id = parseInt(
        $('input[name="properties[Heading]"]:checked').attr("product-id")
      );
      var lining_pair_pro_id = parseInt(
        $('input[name="properties[Lining]"]:checked').attr("product-id")
      );
      var pole_style_pro_id = $(
        'input[name="properties[Pole style]"]:checked'
      ).val();
      var linign_value = $('input[name="properties[Lining]"]:checked').val();
      var pole_width_value = parseInt(
        $('input[name="properties[pole width]"]').val()
      );
      var f_finish_pole_width = $(
        'input[name="properties[Finials & Finish]"]:checked'
      ).attr("data-add-pole-margin");

      //var pole_style_pro_id = $('input[name="properties[Single / Pair]"]:checked').val();

      if (pole_width_value) {
        if (f_finish_pole_width == "true") {
          pole_width_value = pole_width_value + 5;
        } else {
          pole_width_value = pole_width_value;
        }
      } else {
        pole_width_value = 0;
      }
      var rails_width_value = parseInt(
        $('input[name="properties[rails width]"]').val()
      );
      if (rails_width_value) {
        rails_width_value = rails_width_value;
      } else {
        rails_width_value = 0;
      }

      if (pole_style_pro_id == "Poles" || pole_style_pro_id == "exclusive") {
        var finials_finish_pro_id = parseInt(
          $('input[name="properties[Finials & Finish]"]:checked').attr(
            "product-id"
          )
        );
        var finials_finish_pro_type = $(
          'input[name="properties[Finials & Finish]"]:checked'
        ).data("producttype");
        var poles_width_val = parseInt($("#poles-width").val());
        var single_pair_type_title = $(
          'input[name="properties[Single / Pair]"]:checked'
        ).val();
        /*
                      if(single_pair_type_title == 'Par'){
                        var heading_pro_qty = heading_pro_qty*2;
                      }else{
                        var heading_pro_qty = heading_pro_qty;
                      }*/

        var finials_finish_qty = "";

        /* calculation for pole width qty */
        if (finials_finish_pro_type == "standard") {
          if (poles_width_val < 250) {
            finials_finish_qty = 1;
            finials_finish_qty = finials_finish_qty;
          } else {
            poles_width_val = poles_width_val / 250;
            finials_finish_qty = Math.ceil(poles_width_val);
            finials_finish_qty = finials_finish_qty;
          }
        } else {
          if (poles_width_val < 100) {
            finials_finish_qty = 1;
            finials_finish_qty = finials_finish_qty;
          } else {
            poles_width_val = poles_width_val / 100;
            finials_finish_qty = Math.ceil(poles_width_val);
            finials_finish_qty = finials_finish_qty;
          }
        }

        var finials_finish_pro_array = {
          quantity: finials_finish_qty,
          id: finials_finish_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };
        var lining_pair_pro_array = {
          quantity: final_fabric_meter,
          id: lining_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };
        var heading_pro_array = {
          quantity: heading_pro_qty,
          id: heading_pro_id,
          properties: {
            product_collection: "heading-" + new Date().getTime(),
            child: new Date().getTime() + "-heading",
          },
        };
        var single_pair_pro_array = {
          quantity: pro_qty,
          id: single_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };

        if (linign_value == "No lining") {
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Gardintyp: ": curtain_type_title,
                "Antal: ": antal_val,
                "Singel/ par: ": single_pair_type_title,
                "Heltäckande/ dekorativa: ": style_title,
                "Modell: ": heading_title,
                "Foder: ": lining_title,
                "Fallhöjd: ": Height_drop + " Cm",
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Skena/ stång: ": pole_type_val,
                "Längd på skena/ stång: ": pole_width + " Cm",
                "Underprodukt kvantitet: ": quantity,
                parent: new Date().getTime(),
              },
            },
          ];

          if (heading_pro_id) {
            data.push(heading_pro_array);
          }
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
          /*
                        {quantity: pro_qty,id: single_pair_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: heading_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: finials_finish_pro_id,properties: {'child' : new Date().getTime() }}
                */
        } else {
          var finials_finish_pro_id = parseInt(
            $('input[name="properties[Finials & Finish]"]:checked').attr(
              "product-id"
            )
          );
          var finials_finish_pro_type = $(
            'input[name="properties[Finials & Finish]"]:checked'
          ).data("producttype");
          var poles_width_val = parseInt($("#poles-width").val());
          var finials_finish_qty = "";
          var single_pair_type_title = $(
            'input[name="properties[Single / Pair]"]:checked'
          ).val();

          /*
                        if(single_pair_type_title == 'Par'){
                          var heading_pro_qty = heading_pro_qty*2;
                        }else{
                          var heading_pro_qty = heading_pro_qty;
                        }*/

          /* calculation for pole width qty */
          if (finials_finish_pro_type == "standard") {
            if (poles_width_val < 250) {
              finials_finish_qty = 1;
              finials_finish_qty = finials_finish_qty;
            } else {
              poles_width_val = poles_width_val / 250;
              finials_finish_qty = Math.ceil(poles_width_val);
              finials_finish_qty = finials_finish_qty;
            }
          } else {
            if (poles_width_val < 100) {
              finials_finish_qty = 1;
              finials_finish_qty = finials_finish_qty;
            } else {
              poles_width_val = poles_width_val / 100;
              finials_finish_qty = Math.ceil(poles_width_val);
              finials_finish_qty = finials_finish_qty;
            }
          }

          var finials_finish_pro_array = {
            quantity: finials_finish_qty,
            id: finials_finish_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };
          var lining_pair_pro_array = {
            quantity: final_fabric_meter,
            id: lining_pair_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };
          var heading_pro_array = {
            quantity: heading_pro_qty,
            id: heading_pro_id,
            properties: {
              product_collection: "heading-" + new Date().getTime(),
              child: new Date().getTime() + "-heading",
            },
          };
          var single_pair_pro_array = {
            quantity: pro_qty,
            id: single_pair_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };

          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Gardintyp: ": curtain_type_title,
                "Antal: ": antal_val,
                "Singel/ par: ": single_pair_type_title,
                "Heltäckande/ dekorativa: ": style_title,
                "Modell: ": heading_title,
                "Foder: ": lining_title,
                "Fallhöjd: ": Height_drop + " Cm",
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Skena/ stång: ": pole_type_val,
                "Längd på skena/ stång: ": pole_width + " Cm",
                "Underprodukt kvantitet: ": quantity,
                parent: new Date().getTime(),
              },
            },
          ];
          /*
            {quantity: pro_qty,id: single_pair_pro_id,properties: {'child' : new Date().getTime() }},
                  {quantity: pro_qty,id: heading_pro_id,properties: {'child' : new Date().getTime() }},
                  {quantity: pro_qty,id: lining_pair_pro_id,properties: {'child' : new Date().getTime() }},
                  {quantity: pro_qty,id: finials_finish_pro_id,properties: {'child' : new Date().getTime() }}
                  */
          /*
            if (single_pair_pro_id) {
              data.push(single_pair_pro_array);
            }*/
          if (heading_pro_id) {
            data.push(heading_pro_array);
          }
          if (lining_pair_pro_id) {
            data.push(lining_pair_pro_array);
          }
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
        }
      } else if (pole_style_pro_id == "Rails") {
        var finials_finish_pro_id = parseInt(
          $('input[name="properties[Finials & Finish Rails]"]:checked').attr(
            "product-id"
          )
        );
        var single_pair_type_title = $(
          'input[name="properties[Single / Pair]"]:checked'
        ).val();
        var rails_width_val = parseInt($("#rails-width").val());
        var finials_finish_qty = "";

        if (rails_width_val < 100) {
          finials_finish_qty = 1;
          finials_finish_qty = finials_finish_qty;
        } else {
          rails_width_val = rails_width_val / 100;
          finials_finish_qty = Math.ceil(rails_width_val);
          finials_finish_qty = finials_finish_qty;
        }

        /*
                      if(single_pair_type_title == 'Par'){
                        var heading_pro_qty = heading_pro_qty*2;
                      }else{
                        var heading_pro_qty = heading_pro_qty;
                      }*/
        var finials_finish_pro_array = {
          quantity: finials_finish_qty,
          id: finials_finish_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };
        var lining_pair_pro_array = {
          quantity: final_fabric_meter,
          id: lining_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };
        var heading_pro_array = {
          quantity: heading_pro_qty,
          id: heading_pro_id,
          properties: {
            product_collection: "heading-" + new Date().getTime(),
            child: new Date().getTime() + "-heading",
          },
        };
        var single_pair_pro_array = {
          quantity: pro_qty,
          id: single_pair_pro_id,
          properties: {
            child: new Date().getTime(),
          },
        };

        var hanging_with = $("#rails-heading-option").val();

        if (linign_value == "No lining") {
          if (hanging_with) {
            var data = [
              {
                quantity: final_fabric_meter,
                id: main_pro_id,
                properties: {
                  "Gardintyp: ": curtain_type_title,
                  "Antal: ": antal_val,
                  "Singel/ par: ": single_pair_type_title,
                  "Heltäckande/ dekorativa: ": style_title,
                  "Modell: ": heading_title,
                  "Foder: ": lining_title,
                  "Fallhöjd: ": Height_drop + " Cm",
                  "Täckyta/Bredd: ": Window_width + " Cm",
                  "Skena/ stång: ": pole_type_val,
                  "Längd på skena/ stång: ": rails_width + " Cm",
                  "Umgås med: ": hanging_with,
                  "Underprodukt kvantitet: ": quantity,
                  parent: new Date().getTime(),
                },
              },
            ];
          } else {
            var data = [
              {
                quantity: final_fabric_meter,
                id: main_pro_id,
                properties: {
                  "Gardintyp: ": curtain_type_title,
                  "Antal: ": antal_val,
                  "Singel/ par: ": single_pair_type_title,
                  "Heltäckande/ dekorativa: ": style_title,
                  "Modell: ": heading_title,
                  "Foder: ": lining_title,
                  "Fallhöjd: ": Height_drop + " Cm",
                  "Täckyta/Bredd: ": Window_width + " Cm",
                  "Skena/ stång: ": pole_type_val,
                  "Längd på skena/ stång: ": rails_width + " Cm",
                  "Umgås med: ": hanging_with,
                  "Underprodukt kvantitet: ": quantity,
                  parent: new Date().getTime(),
                },
              },
            ];

            lining_pair_pro_array;
          }
          /*
            if (single_pair_pro_id) {
              data.push(single_pair_pro_array);
            }*/
          if (heading_pro_id) {
            data.push(heading_pro_array);
          }
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
          /*{quantity: pro_qty,id: single_pair_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: heading_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: finials_finish_pro_id,properties: {'child' : new Date().getTime() }} */
        } else {
          var finials_finish_pro_id = parseInt(
            $('input[name="properties[Finials & Finish Rails]"]:checked').attr(
              "product-id"
            )
          );
          var single_pair_type_title = $(
            'input[name="properties[Single / Pair]"]:checked'
          ).val();
          var hanging_with = $("#rails-heading-option").val();

          /*
                      if(single_pair_type_title == 'Par'){
                        var heading_pro_qty = heading_pro_qty*2;
                      }else{
                        var heading_pro_qty = heading_pro_qty;
                      }*/
          var finials_finish_pro_array = {
            quantity: finials_finish_qty,
            id: finials_finish_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };
          var lining_pair_pro_array = {
            quantity: final_fabric_meter,
            id: lining_pair_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };
          var heading_pro_array = {
            quantity: heading_pro_qty,
            id: heading_pro_id,
            properties: {
              product_collection: "heading-" + new Date().getTime(),
              child: new Date().getTime() + "-heading",
            },
          };
          var single_pair_pro_array = {
            quantity: pro_qty,
            id: single_pair_pro_id,
            properties: {
              child: new Date().getTime(),
            },
          };

          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Gardintyp: ": curtain_type_title,
                "Antal: ": antal_val,
                "Singel/ par: ": single_pair_type_title,
                "Heltäckande/ dekorativa: ": style_title,
                "Modell: ": heading_title,
                "Foder: ": lining_title,
                "Fallhöjd: ": Height_drop + " Cm",
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Skena/ stång: ": pole_type_val,
                "Längd på skena/ stång: ": rails_width + " Cm",
                "Umgås med: ": hanging_with,
                "Underprodukt kvantitet: ": quantity,
                parent: new Date().getTime(),
              },
            },
          ];

          /*
            if (single_pair_pro_id) {
              data.push(single_pair_pro_array);
            }*/
          if (heading_pro_id) {
            data.push(heading_pro_array);
          }
          if (finials_finish_pro_id) {
            data.push(finials_finish_pro_array);
          }
          if (lining_pair_pro_id) {
            data.push(lining_pair_pro_array);
          }

          /*{quantity: pro_qty,id: single_pair_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: heading_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: lining_pair_pro_id,properties: {'child' : new Date().getTime() }},
                {quantity: pro_qty,id: finials_finish_pro_id,properties: {'child' : new Date().getTime() }} */
        }
      } else {
        if (linign_value == "No lining") {
          var single_pair_type_title = $(
            'input[name="properties[Single / Pair]"]:checked'
          ).val();

          /*
                      if(single_pair_type_title == 'Par'){
                        var heading_pro_qty = heading_pro_qty*2;
                      }else{
                        var heading_pro_qty = heading_pro_qty;
                      }*/
          var data = [
            {
              quantity: final_fabric_meter,
              id: main_pro_id,
              properties: {
                "Gardintyp: ": curtain_type_title,
                "Antal: ": antal_val,
                "Singel/ par: ": single_pair_type_title,
                "Heltäckande/ dekorativa: ": style_title,
                "Modell: ": heading_title,
                "Foder: ": lining_title,
                "Fallhöjd: ": Height_drop + " Cm",
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Skena/ stång: ": pole_type_val,
                "Underprodukt kvantitet: ": quantity,
                parent: new Date().getTime(),
              },
            },
            {
              quantity: pro_qty,
              id: single_pair_pro_id,
              properties: {
                child: new Date().getTime(),
              },
            },
            {
              quantity: heading_pro_qty,
              id: heading_pro_id,
              properties: {
                product_collection: "heading-" + new Date().getTime(),
                child: new Date().getTime() + "-heading",
              },
            },
          ];
        } else {
          var single_pair_type_title = $(
            'input[name="properties[Single / Pair]"]:checked'
          ).val();

          /*
                      if(single_pair_type_title == 'Par'){
                        var heading_pro_qty = heading_pro_qty*2;
                      }else{
                        var heading_pro_qty = heading_pro_qty;
                      }*/
          var data = [
            {
              quantity: parseFloat(final_fabric_meter) || 0,
              id: main_pro_id,
              properties: {
                "Gardintyp: ": curtain_type_title,
                "Antal: ": antal_val,
                "Singel/ par: ": single_pair_type_title,
                "Heltäckande/ dekorativa: ": style_title,
                "Modell: ": heading_title,
                "Foder: ": lining_title,
                "Fallhöjd: ": Height_drop + " Cm",
                "Täckyta/Bredd: ": Window_width + " Cm",
                "Skena/ stång: ": pole_type_val,
                "Underprodukt kvantitet: ": quantity,
                parent: new Date().getTime(),
              },
            },
            {
              quantity: parseFloat(pro_qty) || 0,
              id: single_pair_pro_id,
              properties: {
                child: new Date().getTime(),
              },
            },
            {
              quantity: parseFloat(heading_pro_qty) || 0,
              id: heading_pro_id,
              properties: {
                product_collection: "heading-" + new Date().getTime(),
                child: new Date().getTime() + "-heading",
              },
            },
            {
              quantity: parseFloat(final_fabric_meter) || 0,
              id: lining_pair_pro_id,
              properties: {
                child: new Date().getTime(),
              },
            },
          ];
        }
      }
    }

    jQuery.post(
      "/cart/add.js",
      {
        items: data,
      },
      function (result) {
        setTimeout(function () {
          $.cookie("addtoCartCount", addtoCartCount);
          window.location.href = "/cart"
        }, 500);
      }
    );

    var addtoCartCount = parseInt($.cookie("addtoCartCount"));
    var total_pro_qty = parseInt($(".quantity-wrp #quantity").val());
    if (total_pro_qty == 1) {
      var total_pro_qty = total_pro_qty;
    } else {
      var total_pro_qty = total_pro_qty + 1;
    }
    if (addtoCartCount <= total_pro_qty) {
      setTimeout(function () {
        if (addtoCartCount == total_pro_qty) {
          window.location.href = "/cart";
        } else {
          $("#last-step-add-to-cart").trigger("click");
          //var addtoCartCount = $.cookie("addtoCartCount");
          //var addtoCartCount = parseInt(addtoCartCount) + 1;
          //$.cookie("addtoCartCount", addtoCartCount);
        }
      }, 1000);

      if (addtoCartCount == total_pro_qty) {
        // window.location.href = "/cart";
      } else {
        //$('#last-step-add-to-cart').trigger( "click" );
        //var addtoCartCount = $.cookie("addtoCartCount");
        var addtoCartCount = parseInt(addtoCartCount) + 1;
        $.cookie("addtoCartCount", addtoCartCount);
      }
    }
  });

  ProductRecomSlider();

  //
});

$(document).ready(function () {
  //set initial state.
  $(".pole-style-wrp input").change(function () {
    var pole_style_val = $(this).val();
    if (pole_style_val == "Rails") {
      $(".finials-finish-rail-wrp").show();
      $(".finials-finish-wrp").hide();
    } else if (pole_style_val == "Poles" || pole_style_val == "exclusive") {
      $(".finials-finish-wrp").show();
      $(".finials-finish-rail-wrp").hide();
      if (pole_style_val == "Poles") {
        $(".standard").show();
        $(".exclusive").hide();

        $(".standard:first input").trigger("click");
      } else {
        $(".standard").hide();
        $(".exclusive").show();
        $(".exclusive:first input").trigger("click");
      }
    } else {
      $(".finials-finish-wrp").hide();
      $(".finials-finish-rail-wrp").hide();
    }
  });

  $(".finials-finish-rail-wrp .pro-rails-btn input").change(function () {
    var pro_rails_val = $(this).val();
    if (pro_rails_val == "White Rail") {
      $(".white-rail-pro-wrp").show();
      $(".black-rail-pro-wrp").hide();
      $("#white-rails-1").prop("checked", true);
    } else {
      $(".white-rail-pro-wrp").hide();
      $(".black-rail-pro-wrp").show();
      $("#black-rails-1").prop("checked", true);
    }
  });

  var max_limit = 2; // Max Limit
  var min_limit = 1; // Max Limit

  $(".black-rail-pro-wrp input:checkbox")
    .each(function (index) {
      this.checked = ".white-rail-pro-wrp input:input:checkbox" < max_limit;
      this.checked_min = ".white-rail-pro-wrp input:input:checkbox" > min_limit;
    })
    .change(function () {
      if ($(".black-rail-pro-wrp input:checkbox:checked").length > max_limit) {
        this.checked = false;
      }
      if ($(".black-rail-pro-wrp input:checkbox:checked").length < min_limit) {
        this.checked_min = false;
      }
    });

  $(".white-rail-pro-wrp input:checkbox")
    .each(function (index) {
      this.checked = ".white-rail-pro-wrp input:input:checkbox" < min_limit;
    })
    .change(function () {
      if ($(".white-rail-pro-wrp input:checkbox:checked").length > max_limit) {
        this.checked = false;
      }
    });

  var min_limit = 1; // Max Limit
});

$(document).ready(function () {
  $("body").on(
    "click",
    "#curtain_configurator_modal .radio-btn-wrp input",
    function () {
      cunvertCurrency();
    }
  );
  $("body").on("click", "#curtain_configurator_modal input", function () {
    cunvertCurrency();
  });
});

// curtain configurator calculation function
function CcCalculatur(
  Height_drop,
  Window_width,
  cc_width,
  cc_needed_fabric_ratio,
  cc_vartical_pattern_repeat
) {
  //var pole_style_value = $('input[name="properties[Pole style]"]:checked').val();
  var selected_pole_style = $(
    'input[name="properties[Pole style]"]:checked'
  ).val();
  var add_finials_finish_pole = $(
    'input[name="properties[Finials & Finish]"]:checked'
  ).attr("data-add-pole-margin");
  var add_finials_finish_rails = $(
    'input[name="properties[Finials & Finish Rails]"]:checked'
  ).attr("data-add-pole-margin");
  var curtain_height = parseInt(Height_drop); // 300
  var window_width = parseInt(Window_width); // 200


  var main_select = $("select[data-variant-input]");
  var selectedOption = main_select.find("option:selected");
  var main_pro_v_id = selectedOption.attr("data-variant-id");
  var cc_width = $(".cc_vid_" + main_pro_v_id + " .width").val();

  if (cc_width) {
    var fabric_width = parseInt(cc_width); // 140
  } else {
    var fabric_width = parseInt(0); // 0
  }
  var cc_vartical_pattern_repeat = $(
    ".cc_vid_" + main_pro_v_id + " .vartical_pattern_repeat"
  ).val();

  if (cc_vartical_pattern_repeat) {
    var fabric_vertical_repeat = parseInt(cc_vartical_pattern_repeat); //37
  } else {
    var fabric_vertical_repeat = parseInt(0); //37
  }

  console.log("888fabric_vertical_repeat", fabric_vertical_repeat);
  //var curtain_pole_margin = parseInt(15); //15

  if (selected_pole_style == "Poles" || selected_pole_style == "exclusive") {
    if (add_finials_finish_pole == "true") {
      var curtain_pole_margin = parseInt(5); //5
    } else {
      var curtain_pole_margin = parseInt(0); //0
    }
  } else if (selected_pole_style == "Rails") {
    if (add_finials_finish_rails == "true") {
      var curtain_pole_margin = parseInt(5); //5
    } else {
      var curtain_pole_margin = parseInt(0); //0
    }
  } else {
    var curtain_pole_margin = parseInt(0); //0
  }

  console.log("Curtain Pole Margin: " + curtain_pole_margin);

  var curtain_top_margin = parseInt(40); //40
  var curtain_side_margin = parseInt(10); //10
  var heading_pro_fab_retio = $(
    'input[name="properties[Heading]"]:checked'
  ).data("fabricvalue");

  if (heading_pro_fab_retio) {
    var selected_curtain_type = parseFloat(heading_pro_fab_retio); // 4
  } else if (cc_needed_fabric_ratio) {
    var selected_curtain_type = parseFloat(cc_needed_fabric_ratio); // 4
  } else {
    var selected_curtain_type = parseFloat(0); // 4
  }
  var style_value = $('input[name="properties[style]"]:checked').val();
  var total_window_width = window_width + 2 * curtain_pole_margin;

  console.log("Totle window Width: " + total_window_width);
  var pole_covered_width =
    (fabric_width - curtain_side_margin) / selected_curtain_type;

  console.log("pole_covered_width: " + pole_covered_width);
  var curtain_lengths_exactly = total_window_width / pole_covered_width;
  console.log("curtain_lengths_exactly: " + curtain_lengths_exactly);
  var curtain_lengths_total = Math.ceil(curtain_lengths_exactly);
  console.log("curtain_lengths_total: " + curtain_lengths_total);
  if (Height_drop && Window_width) {
    $("#count-of-lenght").val(curtain_lengths_total);
  } else {
    $("#count-of-lenght").val(1);
  }

  // For each heading options, calculate the "count of length" for each options and append the value as attribute
  $(".heading-options").each(function (index) {
    const $radio = $(this).find('input[type="radio"]');
    const fabricRatio = parseFloat($radio.data("fabricvalue"));
    if (fabricRatio) {
      var selected_curtain_type = parseFloat(fabricRatio); // 4
    } else if (cc_needed_fabric_ratio) {
      var selected_curtain_type = parseFloat(cc_needed_fabric_ratio); // 4
    } else {
      var selected_curtain_type = parseFloat(0); // 4
    }
    const poleCoveredWidth =
      (fabric_width - curtain_side_margin) / selected_curtain_type;
    const curtainLengthsExactly = total_window_width / poleCoveredWidth;
    const curtainLengthsTotal = Math.ceil(curtainLengthsExactly);
    if (Height_drop && Window_width) {
      $(this).find("input").attr("data-count-of-lenght", curtainLengthsTotal);
    }

    $radio.on("click", function () {
      $(".heading-options input").removeAttr("data-checked");
      $(this).attr("data-checked", index);
    });
  });

  var curtains_length_per_side = curtain_lengths_total / 2;
  console.log("curtains_length_per_side: " + curtains_length_per_side);
  var fabric_needed_per_curtain_cm =
    curtain_lengths_total *
    (curtain_height + fabric_vertical_repeat + curtain_top_margin);
  console.log("curtain_lengths_total: " + curtain_lengths_total);
  console.log("curtain_height: " + curtain_height);
  console.log("fabric_vertical_repeat: " + fabric_vertical_repeat);
  console.log("curtain_top_margin: " + curtain_top_margin);
  console.log("fabric_needed_per_curtain_cm: " + fabric_needed_per_curtain_cm);
  var fabric_needed_per_curtain_m = Math.ceil(
    fabric_needed_per_curtain_cm / 100
  );
  console.log("fabric_needed_per_curtain_m: " + fabric_needed_per_curtain_m);

  $(".totle-fabric-meter").val(fabric_needed_per_curtain_m);
  if (fabric_needed_per_curtain_m) {
    var actual_fabric_needed_per_curtain_m = fabric_needed_per_curtain_m;
    var style_value = $('input[name="properties[style]"]:checked').val();
    if (style_value == "Dekorativ gardin") {
      var one_third_fabric_needed_per_curtain_m = actual_fabric_needed_per_curtain_m / 3;
      var fabric_needed_per_curtain_cm =
        fabric_needed_per_curtain_m - one_third_fabric_needed_per_curtain_m;
        actual_fabric_needed_per_curtain_m = Math.ceil(fabric_needed_per_curtain_cm);
      }
    $(".total-meter").text(
      "Tyg: " + actual_fabric_needed_per_curtain_m + " meter"
    );
  } else {
    $(".total-meter").text("");
  }

  if (style_value == "Dekorativ gardin") {
    var one_third_fabric_needed_per_curtain_m = fabric_needed_per_curtain_m / 3;
    fabric_needed_per_curtain_cm =
      fabric_needed_per_curtain_m - one_third_fabric_needed_per_curtain_m;
    var fabric_needed_per_curtain_m = Math.ceil(fabric_needed_per_curtain_cm);
    console.log(
      "9999fabric_needed_per_curtain_cm",
      fabric_needed_per_curtain_cm
    );
    console.log(
      "9999fabric_needed_per_curtain_m",
      fabric_needed_per_curtain_m
    );

  }

  var main_product_price = $(".product-title-main-price").text();
  var money_doubly_currency = $(".price-item .money").attr("doubly-currency");

  //main_product_price = $.main_product_price(myStr);
  main_product_price = $.trim(main_product_price);
  main_product_price = parseFloat(main_product_price);
  main_product_price = main_product_price * fabric_needed_per_curtain_m;
  $(".main-product-price").val(main_product_price);

  var regular_main_price = $(
    ".orignal-price-wrp .price-item--regular-wrp"
  ).data("price");
  regular_main_price = regular_main_price * fabric_needed_per_curtain_m;

  $(".main-product-price").attr("data-price", regular_main_price);
  var regular_main_price = theme.Currency.formatMoney(
    regular_main_price,
    theme.moneyFormat
  );

  $(".main-product-price").html(regular_main_price);
  //$('.main-product-price').text(main_product_price);

  console.log("88888fabric_needed_per_curtain_m", fabric_needed_per_curtain_m);
  $("#final_fabric_meter").val(fabric_needed_per_curtain_m);
  if (fabric_needed_per_curtain_m) {
    $(".main-product-variant").text(
      "Tyg: " + fabric_needed_per_curtain_m + " meter"
    );
  } else {
    $(".main-product-variant").text("Tyg: NA");
  }
}

function BliendCcCalculatur(
  Height_drop,
  Window_width,
  cc_width,
  cc_needed_fabric_ratio,
  cc_vartical_pattern_repeat
) {
  var main_select = $("select[data-variant-input]");
  var selectedOption = main_select.find("option:selected");
  var main_pro_v_id = selectedOption.attr("data-variant-id");
  var curtain_height = parseInt(Height_drop); // 300
  console.log("curtain_height: " + curtain_height);
  var window_width = parseInt(Window_width); // 200
  console.log("window_width: " + window_width);
  var cc_width = $(".cc_vid_" + main_pro_v_id + " .width").val();

  if (cc_width) {
    var fabric_width = parseInt(cc_width); // 140
  } else {
    var fabric_width = parseInt(0); // 0
  }

  console.log("fabric_width: " + fabric_width);
  //var fabric_vertical_repeat = parseInt(cc_needed_fabric_ratio); //37



  var cc_vartical_pattern_repeat = $(
    ".cc_vid_" + main_pro_v_id + " .vartical_pattern_repeat"
  ).val();


  if (cc_vartical_pattern_repeat) {
    var fabric_vertical_repeat = parseInt(cc_vartical_pattern_repeat); //37
  } else {
    var fabric_vertical_repeat = parseInt(0); //37
  }

  var blinds_top_margin = parseInt(40); // 40
  console.log("blinds_top_margin: " + blinds_top_margin);
  var blinds_side_margins = parseInt(20); // 20
  console.log("blinds_side_margins: " + blinds_side_margins);

  var total_fabric_width = fabric_width - blinds_side_margins;
  console.log("Total Fabric Width: " + total_fabric_width);
  var blinds_lengths_total = curtain_height + blinds_top_margin;
  console.log("Blinds Lengths Total: " + blinds_lengths_total);
  if (total_fabric_width < window_width) {
    var fabric_needed_per_curtain =
      blinds_lengths_total * 2 + fabric_vertical_repeat;
  } else {
    var fabric_needed_per_curtain = blinds_lengths_total;
  }

  console.log("fabric_needed_per_curtain in cm: " + fabric_needed_per_curtain);
  var fabric_needed_per_curtain_m = Math.ceil(fabric_needed_per_curtain / 100);
  console.log("fabric_needed_per_curtain_m: " + fabric_needed_per_curtain_m);
  $(".totle-fabric-meter").val(fabric_needed_per_curtain_m);
  if (fabric_needed_per_curtain_m) {
    var actual_fabric_needed_per_curtain_m = fabric_needed_per_curtain_m;
    var style_value = $('input[name="properties[style]"]:checked').val();
    if (style_value == "Dekorativ gardin") {
      var one_third_fabric_needed_per_curtain_m = actual_fabric_needed_per_curtain_m / 3;
      var fabric_needed_per_curtain_cm =
        fabric_needed_per_curtain_m - one_third_fabric_needed_per_curtain_m;
        actual_fabric_needed_per_curtain_m = Math.ceil(fabric_needed_per_curtain_cm);
      }
    $(".total-meter").text(
      "Tyg: " + actual_fabric_needed_per_curtain_m + " meter"
    );
  } else {
    $(".total-meter").text("");
  }
  var main_product_price = $(".product-title-main-price").text();
  var money_doubly_currency = $(".price-item .money").attr("doubly-currency");

  //main_product_price = $.main_product_price(myStr);
  main_product_price = $.trim(main_product_price);
  main_product_price = parseFloat(main_product_price);
  main_product_price = main_product_price * fabric_needed_per_curtain_m;

  $(".main-product-price").val(main_product_price);

  var regular_main_price = $(
    ".orignal-price-wrp .price-item--regular-wrp"
  ).data("price");
  regular_main_price = regular_main_price * fabric_needed_per_curtain_m;
  $(".main-product-price").attr("data-price", regular_main_price);
  var regular_main_price = theme.Currency.formatMoney(
    regular_main_price,
    theme.moneyFormat
  );

  $(".main-product-price").html(regular_main_price);
  //$('.main-product-price').text(main_product_price);

  $("#final_fabric_meter").val(fabric_needed_per_curtain_m);
  if (fabric_needed_per_curtain_m) {
    $(".main-product-variant").text(
      "Tyg: " + fabric_needed_per_curtain_m + " meter"
    );
  } else {
    $(".main-product-variant").text("Tyg: NA");
  }
}

// width number validation
$("#Window-width").change(function () {
  // showLiningReletedPro();
  get_Amount_of_lenght();
  $("#Window-width").trigger("click");
  setTimeout(function () {
    $("#Window-width").trigger("click");
  }, 200);
  setTimeout(function () {
    var width_value = $("#Window-width").val();
    var curtain_type = $(
      'input[name="properties[Curtain type]"]:checked'
    ).val();

    var window_width_key_error_msg = $("#window-width-error-key-press").val();
    if (width_value > 200 && curtain_type == "Blinds") {
      //alert('Please enter width under 200 CM');
      $(".width-error-msg").html(window_width_key_error_msg);
      $("#Window-width").val("");
    }
  }, 300);

  // cunvertCurrency function on key press window width
  cunvertCurrency();
  300;
  setTimeout(function () {
    var width_value = $("#Window-width").val();

    if (width_value) {
      $(".right-header-wrp .fr").hide();
      $(".radio-btn-wrp .fr").hide();
    } else {
      $(".right-header-wrp .fr").show();
      $(".radio-btn-wrp .fr").show();
    }
  }, 200);
});

$("#Window-width").keypress(function (event) {
  setTimeout(function () {
    var width_value = $("#Window-width").val();

    if (width_value) {
      $(".right-header-wrp .fr").hide();
      $(".radio-btn-wrp .fr").hide();
    } else {
      $(".right-header-wrp .fr").show();
      $(".radio-btn-wrp .fr").show();
    }
  }, 200);

  // showLiningReletedPro();
  var keycode = event.which;
  if (keycode == 8) {
    alert();
  }
  if (
    !(
      event.shiftKey == false &&
      (keycode == 46 ||
        keycode == 8 ||
        keycode == 37 ||
        keycode == 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  ) {
    event.preventDefault();
  } else {
    get_Amount_of_lenght();
    setTimeout(function () {
      var width_value = $("#Window-width").val();
      var curtain_type = $(
        'input[name="properties[Curtain type]"]:checked'
      ).val();

      var window_width_key_error_msg = $("#window-width-error-key-press").val();
      if (width_value > 200 && curtain_type == "Blinds") {
        //alert('Please enter width under 200 CM');
        $(".width-error-msg").html(window_width_key_error_msg);
        $("#Window-width").val("");
      }
    }, 300);

    // cunvertCurrency function on key press window width
    cunvertCurrency();
    $("#Window-width").trigger("click");
    setTimeout(function () {
      $("#Window-width").trigger("click");
    }, 200);
  }

  var headingvelvet_product = $("#headingvelvet-product").val();
  if (headingvelvet_product == "true") {
    $(".heading-velvet-product").addClass("active");
    $(".heading-product").addClass("in-active");
    $(".heading-velvet-product:first input").trigger("click");
  } else {
    // $(".heading-product:first input").trigger("click");
  }
});

// width number validation
$("#rails-width").keypress(function (event) {
  var keycode = event.which;
  if (
    !(
      event.shiftKey == false &&
      (keycode == 46 ||
        keycode == 8 ||
        keycode == 37 ||
        keycode == 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  ) {
    event.preventDefault();
  }
  // cunvertCurrency function on key press rails width
  cunvertCurrency();
  setTimeout(function () {
    $("#rails-width").trigger("click");
  }, 500);
  third_Stap_Cal();
});

$("#rails-width").change(function (event) {
  var keycode = event.which;
  if (
    !(
      event.shiftKey == false &&
      (keycode == 46 ||
        keycode == 8 ||
        keycode == 37 ||
        keycode == 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  ) {
    event.preventDefault();
  }
  // cunvertCurrency function on key press rails width
  cunvertCurrency();
  setTimeout(function () {
    $("#rails-width").trigger("click");
  }, 500);
  third_Stap_Cal();
});

$("#Height-drop").change(function () {
  // showLiningReletedPro();
  height_Input_Field();
});

// height number validation
$("#Height-drop").keypress(function (event) {
  // showLiningReletedPro();
  height_Input_Field();
});

function height_Input_Field() {
  var keycode = event.which;
  if (
    !(
      event.shiftKey == false &&
      (keycode == 46 ||
        keycode == 8 ||
        keycode == 37 ||
        keycode == 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  ) {
    event.preventDefault();
  }
  // cunvertCurrency function on key press height drop
  cunvertCurrency();
  get_Amount_of_lenght();
  $("#Height-drop").trigger("click");
  setTimeout(function () {
    $("#Height-drop").trigger("click");
  }, 200);

  var headingvelvet_product = $("#headingvelvet-product").val();
  if (headingvelvet_product == "true") {
    $(".heading-velvet-product").addClass("active");
    $(".heading-product").addClass("in-active");
    $(".heading-velvet-product:first input").trigger("click");
  } else {
    // $(".heading-product:first input").trigger("click");
  }
}

$("#poles-width").keypress(function (event) {
  var keycode = event.which;
  if (
    !(
      event.shiftKey == false &&
      (keycode == 46 ||
        keycode == 8 ||
        keycode == 37 ||
        keycode == 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  ) {
    event.preventDefault();
  }

  setTimeout(function () {
    $("#poles-width").trigger("click");
  }, 500);
  third_Stap_Cal();
});

$("#poles-width").change(function (event) {
  setTimeout(function () {
    $("#poles-width").trigger("click");
  }, 500);
  third_Stap_Cal();
});

$("input").bind("keypress keyup keydown", function (event) {
  //var width_lenght = width_value.length;
  setTimeout(function () {
    var width_value = $("#Window-width").val();
    if (!width_value) {
      $(".right-header-wrp .fr").show();
      $(".radio-btn-wrp .fr").show();
    }
  }, 200);

  var evtType = event.type;
  var eWhich = event.which;
  var echarCode = event.charCode;
  var ekeyCode = event.keyCode;

  switch (evtType) {
    case "keypress":
      $("#poles-width").trigger("click");
      $("#rails-width").trigger("click");
      $("#Height-drop").trigger("click");
      $("#Window-width").trigger("click");
      break;
    case "keyup":
      $("#poles-width").trigger("click");
      $("#rails-width").trigger("click");
      $("#Height-drop").trigger("click");
      $("#Window-width").trigger("click");
      break;
    case "keydown":
      $("#poles-width").trigger("click");
      $("#rails-width").trigger("click");
      $("#Height-drop").trigger("click");
      $("#Window-width").trigger("click");
      break;
    default:
      break;
  }
});

function get_Amount_of_lenght() {
  var curtain_type_title = $(
    'input[name="properties[Curtain type]"]:checked'
  ).val();
  var main_pro_v_id = $("#ProductSelect-product-template").val();
  var cc_vartical_pattern_repeat = $(
    ".cc_vid_" + main_pro_v_id + " .vartical_pattern_repeat"
  ).val();
  var cc_needed_fabric_ratio = $(
    ".cc_vid_" + main_pro_v_id + " .needed_fabric_ratio"
  ).val();
  var cc_width = $(".cc_vid_" + main_pro_v_id + " .width").val();
  // windowwidth
  var Window_width = $('input[name="properties[Window width]"]').val();
  // Height drop
  var Height_drop = $('input[name="properties[Height drop]"]').val();

  if (curtain_type_title == "Curtains") {
    // Call CcCalculatur function
    CcCalculatur(
      Height_drop,
      Window_width,
      cc_width,
      cc_needed_fabric_ratio,
      cc_vartical_pattern_repeat
    );
  } else {
    // Call CcCalculatur function
    BliendCcCalculatur(
      Height_drop,
      Window_width,
      cc_width,
      cc_needed_fabric_ratio,
      cc_vartical_pattern_repeat
    );
  }
  $(".heading-options").each(function (index) {
    var single_pair_selected = $(
      'input[name="properties[Single / Pair]"]:checked'
    ).val();
    var heading_price_data = $(this).find("input").data("price-orignal");
    var count_of_lenght = $(this).find("input").attr("data-count-of-lenght") || $("#count-of-lenght").val();

    if (single_pair_selected == "Par") {
      if (heading_price_data) {
        var heading_price = heading_price_data * parseInt(count_of_lenght);
        heading_price = heading_price * 1;
      } else {
        heading_price = 0;
      }
    } else {
      if (heading_price_data) {
        heading_price = heading_price_data * parseInt(count_of_lenght);
      } else {
        heading_price_data = 0;
      }
    }

    var heading_price_currency = theme.Currency.formatMoney(
      heading_price,
      theme.moneyFormat
    );

    $(this).find(".product-price").text(heading_price_currency);
  });

  /* ram */

  if (Window_width && Height_drop) {
    var final_fabric_meter = $("#final_fabric_meter").val();
    $(".lining-options").each(function (index) {
      var lining_price_data = $(this).find("input").data("price-orignal");

      var lining_price = lining_price_data * final_fabric_meter;

      var lining_price_currency = theme.Currency.formatMoney(
        lining_price,
        theme.moneyFormat
      );

      $(this).find(".product-price").text(lining_price_currency);
    });
  }
}

/* incrementValue */
function subincrementValue() {
  var curtain_type_title = $(
    'input[name="properties[Curtain type]"]:checked'
  ).val();
  var value = parseInt(document.getElementById("quantity").value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  if (value < 6) {
    document.getElementById("quantity").value = value;
  }
  var fabric_needed_per_curtain_m = $("#final_fabric_meter").val();
  fabric_needed_per_curtain_m = fabric_needed_per_curtain_m * value;
  if (fabric_needed_per_curtain_m) {
    $(".main-product-variant").text(
      "Tyg: " + fabric_needed_per_curtain_m + " meter"
    );
  } else {
    $(".main-product-variant").text("Tyg: NA");
  }
  // main product price
  var main_product_price = $(".main-product-price").attr("data-price");
  if (!main_product_price) {
    var main_product_price = 0;
  }
  var total_main_product_price = main_product_price * value;
  var main_total_lining_price = total_main_product_price - main_product_price;

  var main_product_price_currency = theme.Currency.formatMoney(
    total_main_product_price,
    theme.moneyFormat
  );
  $(".main-product-price").html(main_product_price_currency);

  // lining price
  var lining_price = $(".lining-price").attr("data-price");
  if (!lining_price) {
    var lining_price = 0;
  }
  var total_lining_price = lining_price * value;
  var lining_total_lining_price = total_lining_price - lining_price;
  var lining_price_currency = theme.Currency.formatMoney(
    total_lining_price,
    theme.moneyFormat
  );
  $(".preview-price.lining-price").html(lining_price_currency);

  // finials & finish price
  var finials_finish_price = $(".preview-price.finials-finish-price").attr(
    "data-price"
  );
  if (!finials_finish_price) {
    var finials_finish_price = 0;
  }
  var total_finials_finish_price = finials_finish_price * value;
  var finials_total_finials_type_price =
    total_finials_finish_price - finials_finish_price;

  var finials_finish_price_currency = theme.Currency.formatMoney(
    total_finials_finish_price,
    theme.moneyFormat
  );
  $(".preview-price.finials-finish-price").html(finials_finish_price_currency);

  // header price
  var heading_type_price = $(".preview-price.heading-price").attr("data-price");
  if (!heading_type_price) {
    var heading_type_price = 0;
  }
  total_heading_type_price = parseFloat(heading_type_price) * parseInt(value);
  var heading_total_heading_type_price =
    total_heading_type_price - heading_type_price;
  var heading_type_price_currency = theme.Currency.formatMoney(
    total_heading_type_price,
    theme.moneyFormat
  );
  $(".preview-price.heading-price").html(heading_type_price_currency);

  var total_orignal_price = $(".totle-orignal-price").attr("data-price");
  console.log("TOTAL ORIGINAL PRICE", total_orignal_price);

  if (curtain_type_title == "Blinds") {
    var total_orignal_price =
      parseFloat(total_orignal_price) +
      parseFloat(main_total_lining_price) +
      parseFloat(lining_total_lining_price);
  } else {
    var total_orignal_price =
      (parseFloat(total_orignal_price) || 0) +
      (parseFloat(main_total_lining_price) || 0) +
      (parseFloat(heading_total_heading_type_price) || 0) +
      (parseFloat(finials_total_finials_type_price) || 0) +
      (parseFloat(lining_total_lining_price) || 0);
  }

  $(".totle-orignal-price").attr("total-data-price", total_orignal_price);
  var total_orignal_price = theme.Currency.formatMoney(
    total_orignal_price,
    theme.moneyFormat
  );
  $(".totle-orignal-price").html(total_orignal_price);
}

/* discriminantValue */
function subdiscriminantValue() {
  var curtain_type_title = $(
    'input[name="properties[Curtain type]"]:checked'
  ).val();

  var value = parseInt(document.getElementById("quantity").value, 10);
  value = isNaN(value) ? 0 : value;
  value--;
  if (value > 0) {
    document.getElementById("quantity").value = value;

    var fabric_needed_per_curtain_m = $("#final_fabric_meter").val();
    fabric_needed_per_curtain_m = fabric_needed_per_curtain_m * value;
    if (fabric_needed_per_curtain_m) {
      $(".main-product-variant").text(
        "Tyg: " + fabric_needed_per_curtain_m + " meter"
      );
    } else {
      $(".main-product-variant").text("Tyg: NA");
    }
    // main product price
    var main_product_price = $(".main-product-price").attr("data-price");
    if (!main_product_price) {
      var main_product_price = 0;
    }
    var total_main_product_price = main_product_price * value;
    var final_total_main_product_price =
      total_main_product_price - main_product_price;
    var main_product_price_currency = theme.Currency.formatMoney(
      total_main_product_price,
      theme.moneyFormat
    );
    $(".main-product-price").html(main_product_price_currency);

    // lining price
    var lining_price = $(".lining-price").attr("data-price");
    if (!lining_price) {
      var lining_price = 0;
    }
    var total_lining_price = lining_price * value;
    var final_total_heading_type_price = total_lining_price - lining_price;
    var lining_price_currency = theme.Currency.formatMoney(
      total_lining_price,
      theme.moneyFormat
    );
    $(".preview-price.lining-price").html(lining_price_currency);

    // finials & finish price
    var finials_finish_price = $(".preview-price.finials-finish-price").attr(
      "data-price"
    );
    if (!finials_finish_price) {
      var finials_finish_price = 0;
    }
    var total_finials_finish_price = finials_finish_price * value;
    var final_total_heading_type_price =
      total_finials_finish_price - finials_finish_price;
    var finials_finish_price_currency = theme.Currency.formatMoney(
      total_finials_finish_price,
      theme.moneyFormat
    );
    $(".preview-price.finials-finish-price").html(
      finials_finish_price_currency
    );

    // header price
    var heading_type_price = $(".preview-price.heading-price").attr(
      "data-price"
    );
    if (!heading_type_price) {
      var heading_type_price = 0;
    }
    total_heading_type_price = parseFloat(heading_type_price) * parseInt(value);
    var final_total_heading_type_price =
      total_heading_type_price - heading_type_price;
    var heading_type_price_currency = theme.Currency.formatMoney(
      total_heading_type_price,
      theme.moneyFormat
    );
    $(".preview-price.heading-price").html(heading_type_price_currency);

    var total_orignal_price = $(".totle-orignal-price").attr(
      "total-data-price"
    );

    if (curtain_type_title == "Blinds") {
      var total_orignal_price =
        parseFloat(total_orignal_price) -
        parseFloat(lining_price) -
        parseFloat(main_product_price);
    } else {
      var total_orignal_price =
        (parseFloat(total_orignal_price) || 0) -
        (parseFloat(finials_finish_price) || 0) -
        (parseFloat(lining_price) || 0) -
        (parseFloat(main_product_price) || 0) -
        (parseFloat(heading_type_price) || 0);
    }

    var total_orignal_price_currency = theme.Currency.formatMoney(
      total_orignal_price,
      theme.moneyFormat
    );
    $(".totle-orignal-price").html(total_orignal_price_currency);
    $(".totle-orignal-price").attr("total-data-price", total_orignal_price);
  }
}

// cunvertCurrency function for curtain configurator
function cunvertCurrency() {
  var selected_current_currency = $.trim($("#selected_current_currency").val());
  $(".active-currency-wrp").hide();
  $(".right-header-wrp").hide();

  setTimeout(function () {
    $(".doubly-nice-select").removeClass("currency-switcher");
    $(".doubly-nice-select").addClass("currency-switcher-wrp");
    $(".doubly-nice-select .list li").each(function () {
      var currency_data_value = $(this).data("value");
      if (currency_data_value == selected_current_currency) {
        $(this).trigger("click");
      }
      //alert();
    });
    $(".right-header-wrp").show();
  }, 1000);
}

function productContentDetails() {
  // curtain type content
  var curtain_type_detail = $('input[name="properties[Curtain type]"]:checked')
    .siblings(".curtain-type-details")
    .html();
  $(".curtain-type-wrp .step-description").html(curtain_type_detail);

  $(".radio-btn-wrp input").click(function () {
    var curtain_type_detail = $(this).siblings(".curtain-type-details").html();

    $(".curtain-type-wrp .step-description").html(curtain_type_detail);
  });

  // style content
  var style_desc_detail = $('input[name="properties[style]"]:checked')
    .siblings(".style-desc-details")
    .html();
  $(".style-wrp .step-description").html(style_desc_detail);

  $(".radio-btn-wrp input").click(function () {
    var style_desc_detail = $(this).siblings(".style-desc-details").html();

    $(".style-wrp .step-description").html(style_desc_detail);
  });

  // single pair content
  var single_pair_pro_detail = $(
    'input[name="properties[Single / Pair]"]:checked'
  )
    .siblings(".single-pair-indisual-product-details")
    .html();
  $(".single-pair-wrp .step-description").html(single_pair_pro_detail);

  $(".radio-btn-wrp input").click(function () {
    var single_pair_pro_val = $(this)
      .siblings(".single-pair-indisual-product-details")
      .html();

    $(".single-pair-wrp .step-description").html(single_pair_pro_val);
  });

  // heading content
  var heading_pro_detail = $('input[name="properties[Heading]"]:checked')
    .siblings(".heading-indisual-product-details")
    .html();
  $(".header-wrp .step-description").html(heading_pro_detail);

  $(".radio-btn-wrp input").click(function () {
    var heading_pro_detail = $(this)
      .siblings(".heading-indisual-product-details")
      .html();

    $(".header-wrp .step-description").html(heading_pro_detail);
  });

  // lining content
  var lining_pro_detail = $('input[name="properties[Lining]"]:checked')
    .siblings(".lining-product-details")
    .html();
  $(".lining-wrp .step-description").html(lining_pro_detail);

  $(".radio-btn-wrp input").click(function () {
    var lining_pro_detail = $(this).siblings(".lining-product-details").html();

    $(".lining-wrp .step-description").html(lining_pro_detail);
  });

  // pole type content
  var pole_type_detail = $('input[name="properties[Pole style]"]:checked')
    .siblings(".pole-type-details")
    .html();
  $(".pole-style-wrp .step-description").html(pole_type_detail);

  $(".radio-btn-wrp input").click(function () {
    var pole_type_detail = $(this).siblings(".pole-type-details").html();

    $(".pole-style-wrp .step-description").html(pole_type_detail);
  });

  // finial and finish content
  var pole_finials_finish_detail = $(
    'input[name="properties[Finials & Finish]"]:checked'
  )
    .siblings(".pole-finials-finish-product-details")
    .html();
  $(".finials-finish-wrp .step-description").html(pole_finials_finish_detail);

  $(".radio-btn-wrp input").click(function () {
    var pole_finials_finish_detail = $(this)
      .siblings(".pole-finials-finish-product-details")
      .html();

    $(".finials-finish-wrp .step-description").html(pole_finials_finish_detail);
  });

  // finial and finish content
  var rails_finials_finish_detail = $(
    'input[name="properties[Finials & Finish Rails]"]:checked'
  )
    .siblings(".rails-finials-finish-product-details")
    .html();
  $(".finials-finish-rail-wrp .step-description").html(
    rails_finials_finish_detail
  );

  $(".radio-btn-wrp input").click(function () {
    var pole_finials_finish_detail = $(this)
      .siblings(".rails-finials-finish-product-details")
      .html();

    $(".finials-finish-rail-wrp .step-description").html(
      pole_finials_finish_detail
    );
  });
}